export const translations = {
  EN: {
    // Layout / nav
    nav_dashboard: "Dashboard",
    nav_assets: "Assets",
    nav_faults: "Faults",
    nav_compliance: "Compliance",
    nav_users: "Users",
    nav_reports: "Reports",
    nav_activity: "Activity logs",
    nav_help: "Help & Guide",
    nav_policies: "Policies & Procedures",
    brand_subtitle: "School Assets Management",
    nav_section: "Navigation",
    lang_label: "Language",
    backup: "Backup",
    backing_up: "Backing up…",
    signed_in_as: "Signed in as",
    sign_out: "Sign out",
    backup_ok: "Backup downloaded",
    backup_err: "Backup not available yet",
    topbar_title: "School Assets Management",

    // Login
    welcome_back: "Welcome back",
    login_tagline: "Manage every asset, from classroom to campus.",
    login_sub: "Centralize every school asset across all campuses — track ownership, maintenance, and compliance from one place.",
    tab_signin: "Sign in",
    tab_register: "Create account",
    email: "Email",
    password: "Password",
    signing_in: "Signing in…",
    demo_accounts: "Demo accounts",
    full_name: "Full name",
    department: "Department",
    dept_placeholder: "e.g. Science Department",
    creating: "Creating…",
    create_staff: "Create staff account",
    footer_copy: "YPJ School Assets Management",
    login_hero_label: "Built for schools",
    login_hero_quote: "An Innovative and Progressive School with Empathy, Integrity and Open Minded",
    login_hero_attr: "YPJ School",

    // Assets list
    inventory: "Inventory",
    assets: "Assets",
    add_asset: "Add asset",
    search_placeholder: "Search by name, tag or serial number…",
    all_campuses: "All campuses",
    all_categories: "All categories",
    all_statuses: "All statuses",
    col_tag: "Tag",
    col_asset: "Asset",
    col_category: "Category",
    asset_property_by: "Asset Property Of",
    col_asset_property_of: "Asset Property Of",
    asset_type_school: "School Asset",
    asset_type_company: "Company Asset",
    col_campus: "Campus",
    col_supervisor: "Supervisor",
    supervisor_name: "Supervisor Name",
    supervisor_email: "Supervisor Email",
    supervisor_placeholder: "e.g. supervisor@fmi.com",
    col_employee_id: "Employee ID",
    col_room: "Room",
    col_assigned: "Assigned",
    col_status: "Status",
    col_book_value: "Book Value",
    loading: "Loading…",
    no_assets: "No assets found",
    no_assets_sub: "Try adjusting filters or add your first asset.",
    last_refreshed: "Last refreshed",
    count_asset: "asset",
    count_assets: "assets",
    asset_categories: "categories",
    expand_all: "Expand all",
    collapse_all: "Collapse all",

    // Status labels
    status_active: "Active",
    status_in_repair: "In Repair",
    status_retired: "Retired",
    status_lost: "Lost",

    // Categories
    cat_it: "IT Equipment",
    cat_av: "AV Equipment",
    cat_furniture: "Furniture",
    cat_lab: "Lab Equipment",
    cat_vehicles: "Vehicles",
    cat_books: "Books",
    cat_sports: "Sports",
    cat_music: "Music Equipment",
    cat_learning: "Learning Tools",
    cat_erg: "ERG / Fire Drill Equipment",
    cat_housekeeping: "Housekeeping Equipment",
    cat_firstaid: "First Aid / AED Equipment",
    cat_tools: "Work Tools",
    cat_other: "Other",

    // Asset form
    back: "Back",
    edit_asset: "Edit asset",
    new_asset: "New asset",
    register_asset: "Register a new asset",
    section_basic: "01 — Identity",
    asset_name: "Asset name",
    asset_tag: "Asset tag / barcode",
    asset_tag_placeholder: "e.g. FUR-DSK-0001",
    rn_button: "Restore asset names from an earlier export",
    rn_hint: "upload an older asset export (.xlsx); assets whose name is only a number get their old name back.",
    rn_done: "{n} names restored, {m} not found in the file",
    bu_pick: "Set school unit…",
    bu_apply: "Apply unit",
    bu_done: "{n} assets updated",
    unit_skipped: "{n} skipped",
    unit_auto: "Match units to labs and carts",
    assign_approval: "Assigning needs supervisor approval",
    assign_approval_yes: "Yes, copy admins and leaders (important assets)",
    assign_approval_yes2: "Yes, copy admins only (regular assets)",
    assign_approval_hint: "When on: the recipient's supervisor (the school head for SMP) approves first, then the teacher confirms. Admin resources and campus admin are always copied; the first option also copies the campus leaders, so use the second for regular items like lab tools.",
    aa_on: "Approval + CC leaders",
    aa_status: "Approval",
    bu_status: "School unit",
    bu_unset: "not set",
    bl_status: "Lending",
    bl_state_1: "lendable",
    bl_state_0: "not for lending",
    bl_state_none: "not decided yet",
    bl_badge_1: "Lendable",
    bl_badge_0: "Not lent",
    aa_state_0: "no approval needed",
    aa_state_1: "approval, CC admins + leaders",
    aa_state_2: "approval, CC admins only",
    aa_state_mixed: "mixed (differs between the ticked assets)",
    aa_badge_1: "Approval · +leaders",
    aa_badge_2: "Approval · admins",
    aa_on2: "Approval, CC admins only",
    aa_off: "No approval needed",
    aa_done_on: "{n} assets now need supervisor approval to be assigned",
    aa_done_off: "{n} assets no longer need approval to be assigned",
    aa_waiting: "{n} waiting for approval by {name}",
    aa_cc_missing: "These people on the e-mail copy list are not registered users yet, so they got no copy: {names}. Add them in the Users menu.",
    aa_unit_scope: "Some assets were skipped: they belong to a school unit your account does not handle.",
    aa_no_supervisor: "Some assets were skipped: they need approval but the teacher has no supervisor registered. Fill in the supervisor in the Users menu.",
    aa_title: "Hand-overs waiting for your approval",
    aa_hint: "Approve so the teacher can check and accept the assets, or reject with a reason.",
    aa_to: "to",
    aa_approve: "Approve",
    aa_approved_toast: "Approved. The teacher has been asked to confirm.",
    aa_rejected_toast: "Rejected. The admin has been notified.",
    aa_status_waiting: "Waiting for approval {name}",
    bl_on: "Make lendable",
    bl_off: "Not for lending",
    bl_done_on: "{n} assets are now lendable",
    bl_done_off: "{n} assets are no longer lendable",
    qr_mode_loan: "Lent assets (IT devices, Multimedia and Tools)",
    qr_mode_fixed: "Assigned assets (not lent)",
    qr_fixed_hint: "Stickers for assets that stay in place, such as furniture and wall clocks. Scanning one opens the asset page, not a loan. The caption ends with the room.",
    qr_all_categories: "All categories",
    qr_select_none: "Clear selection",
    sp_button: "Use this photo for all numbered copies",
    sp_confirm: "Use this photo for {n} other assets with the same name (#1, #2, …)? Their current photos are replaced.",
    sp_none: "No other numbered copies with this name were found.",
    sp_done: "Photo applied to {n} assets",
    bu_auto_hint: "Units in a cart or lab take that cart's / lab's school unit (as set for the schedule). The rest without a unit: Student's Desktop → SMP, Student's Laptop → SD, iPads named PAUD or SD.",
    asset_tag_auto: "Generated automatically",
    asset_tag_auto_hint: "A unique numeric barcode number is assigned when the asset is saved and cannot be edited.",
    campus: "Campus",
    select_campus: "Select campus…",
    room_location: "Room / Location",
    room_placeholder: "e.g. Computer Lab A",
    status: "Status",
    description: "Description",
    serial_number: "Serial number",
    initial_owner: "Custodian / PIC (initial owner)",
    initial_owner_placeholder: "e.g. Maria Hernandez",
    section_financials: "07 — Financials & Depreciation",
    purchase_price: "Purchase price (USD)",
    purchase_date: "Purchase date",
    useful_life: "Useful life (years)",
    warranty_end: "Warranty end date",
    supplier: "Supplier / vendor",
    section_media: "08 — Photo & Documents",
    section_location: "02 — Location & Custodian",
    section_acquisition: "03 — Acquisition",
    section_condition: "04 — Condition & Inspection",
    section_maintenance: "05 — Maintenance",
    section_warranty: "06 — Warranty",
    asset_code: "Asset ID",
    asset_code_placeholder: "Generated automatically on save",
    asset_code_hint: "Locked: the ID is generated automatically (campus-category-number).",
    asset_code_hint_super: "Only super admins can edit this. Leave empty on a new asset to generate it automatically.",
    item_type: "Asset type",
    item_type_placeholder: "e.g. Student desk",
    brand: "Brand",
    brand_placeholder: "e.g. IKEA",
    model: "Model",
    model_placeholder: "e.g. Single desk 60x40",
    unit: "Unit",
    select_generic: "Select…",
    building: "Building",
    building_placeholder: "e.g. SMP Building",
    asset_department: "Department / function",
    asset_department_placeholder: "e.g. Academic",
    user_type: "User type",
    acquisition_type: "Acquisition type",
    po_number: "PO / contract no.",
    po_placeholder: "e.g. PO-2026-00125",
    funding_source: "Funding source",
    funding_placeholder: "e.g. School budget",
    asset_condition: "Condition",
    condition_notes: "Condition notes",
    last_inspection: "Last inspection date",
    next_inspection: "Next inspection date",
    maintenance_required: "Maintenance required",
    last_maintenance: "Last maintenance date",
    next_maintenance: "Next maintenance date",
    maintenance_provider: "Maintenance provider",
    maintenance_provider_placeholder: "Vendor or internal",
    maintenance_cost: "Maintenance cost (USD)",
    warranty_start: "Warranty start date",
    warranty_provider: "Warranty provider",
    residual_value: "Residual value (USD)",
    updated_label: "Last updated",
    opt_yes: "Yes",
    opt_no: "No",
    unit_paud: "PAUD",
    unit_sd: "SD",
    unit_smp: "SMP",
    unit_admin: "Administration",
    unit_shared: "Shared / other",
    cond_good: "Good",
    cond_fair: "Fair",
    cond_poor: "Poor",
    cond_damaged: "Damaged",
    acq_purchase: "Purchase",
    acq_donation: "Donation",
    acq_transfer: "Transfer",
    ut_employee: "Employee",
    ut_shared: "Shared",
    ut_classroom: "Classroom",
    doc_invoice: "Invoice / receipt",
    doc_warranty: "Warranty document",
    doc_supporting: "Supporting document",
    due_title: "Inspections & maintenance due",
    due_none: "Nothing due in the next 60 days.",
    fx_note: "Values are stored in Rupiah and shown in USD at 1 USD = Rp {rate} (as of {date}, source: ExchangeRate-API).",
    fx_note_fallback: "Values are stored in Rupiah and shown in USD at an estimated rate of 1 USD = Rp {rate} (current rate unavailable).",
    due_send_now: "Send reminders now",
    due_sending: "Sending…",
    due_send_confirm: "Send reminder emails now to campus heads and the general inbox for everything due within 30 days or overdue?",
    due_send_none: "Nothing is due within 30 days or overdue — no email sent.",
    due_send_no_email: "Email is not configured on the server — nothing was sent.",
    due_send_no_recipients: "No reminder recipients are configured — nothing was sent.",
    due_sent: "Reminders sent: {items} item(s) in {emails} email(s).",
    due_inspection: "Inspection",
    due_maintenance: "Maintenance",
    due_days_overdue: "days overdue",
    due_today: "due today",
    due_in: "in",
    due_days: "days",
    asset_photo: "Asset photo",
    click_upload_photo: "Click to upload photo",
    uploading: "Uploading…",
    documents_label: "Documents (PDF, etc.)",
    attach_doc: "Attach a document",
    upload_size_limit: "Any size: the photo is shrunk automatically to max 100 KB when saved",
    upload_doc_size_limit: "Max file size: 1 MB",
    photo_uploaded: "Photo uploaded",
    doc_attached: "Document attached",
    photo_too_large: "This photo could not be shrunk to 100 KB. Try another image.",
    doc_too_large: "Document must be 1 MB or smaller.",
    compliance_created: "Compliance item created",
    delete_compliance_confirm: "Delete this compliance item?",
    fault_updated: "Fault updated",
    user_created_ok: "User created",
    user_updated_ok: "User updated",
    edit_user: "Edit user",
    new_password_optional: "New password (optional)",
    leave_blank_unchanged: "Leave blank to keep unchanged",
    delete_user_confirm: "Delete {{name}}?",
    asset_transferred: "Asset transferred",
    transfer_request_submitted: "Transfer request submitted for approval.",
    transfer_owner_required: "Please select or enter a new owner.",
    nav_my_assets: "My Assets",
    nav_user_assets: "Assets by User",
    ma_eyebrow: "Custody",
    ma_title: "My assets",
    ma_subtitle: "Items handed over to you. New items are recorded under your name only after you confirm you have received them.",
    ma_kpi_personal: "Personal assets",
    ma_kpi_class: "Class assets",
    ma_kpi_pending: "Awaiting confirmation",
    ma_kpi_value: "Book value",
    ma_pending_title: "Please confirm receipt",
    ma_pending_hint: "Check the physical items, then press Accept. Reject with a reason if something does not match.",
    ma_accept: "Accept",
    ma_accept_selected: "Accept selected ({n})",
    ma_accept_all: "Accept all",
    ma_reject: "Reject",
    ma_reject_selected: "Reject selected ({n})",
    ma_reject_title: "Reject hand-over",
    ma_reject_reason: "Reason (required)",
    ma_reject_placeholder: "e.g. Item is not in the room / damaged",
    ma_accepted_toast: "{n} item(s) accepted",
    ma_rejected_toast: "{n} item(s) rejected",
    ma_from: "From",
    ma_by: "Handed over by",
    ma_new_asset: "New asset",
    ma_kind_personal: "Personal",
    assign_kind: "Held as",
    asset_quantity: "Quantity",
    asset_quantity_hint: "1 = a single asset. For identical items (10 quiz bells) enter the number: one asset per item is created.",
    asset_quantity_many: "Creates {n} assets named \"{name} #1…\", each with its own barcode and the same photo, room and owner.",
    asset_created_many: "{n} assets created: {first} … {last}",
    assign_kind_hint: "Personal: the person holds it (a laptop, a tablet). Class: it stays in the room and the teacher looks after it (instruments, teaching aids).",
    ma_kind_class: "Class",
    ma_tab_all: "All",
    ma_empty: "No assets have been handed over to you yet.",
    ma_waiting_days: "waiting {n} day(s)",
    ma_col_asset: "Asset",
    ma_col_location: "Location",
    ma_col_category: "Category",
    ma_col_type: "Type",
    ma_col_value: "Book value",
    ma_col_status: "Status",
    ua_title: "Assets by user",
    ua_subtitle: "Who holds what. Hand-overs that are not confirmed yet are not counted.",
    ua_kpi_users: "Users",
    ua_kpi_with_users: "Assets held by users",
    ua_kpi_unassigned: "Without a holder",
    ua_kpi_pending: "Awaiting confirmation",
    ua_search: "Search user…",
    ua_col_user: "User",
    ua_col_personal: "Personal",
    ua_col_class: "Class",
    ua_col_pending: "Pending",
    ua_col_value: "Book value",
    ua_detail_title: "Assets held by {name}",
    ua_detail_hint: "Select a user in the table to see their assets.",
    ua_pending_list: "Hand-overs awaiting confirmation",
    ua_cancel: "Cancel",
    ua_cancelled_toast: "Hand-over cancelled",
    ua_handover_btn: "Class hand-over",
    ua_none: "No users found.",
    ho_title: "Change responsible teacher",
    ho_hint: "The new teacher gets an e-mail (supervisor in CC) and checks every asset: accept, or report missing/damaged. The change takes effect when all are checked.",
    ho_recipient: "Recipient",
    ho_recipient_ph: "Select a user…",
    ho_room: "Room / location",
    ho_room_ph: "Select a room…",
    ho_select_all: "Select all",
    ho_note: "Note (optional)",
    ho_kind: "Type",
    ho_none: "No active assets in this room.",
    ho_current: "now: {name}",
    ho_waiting: "waiting for confirmation",
    ho_submit: "Send for confirmation",
    ho_result: "{n} item(s) sent for confirmation",
    ho_skipped: "{n} skipped",
    awaiting_confirmation: "Awaiting confirmation",
    awaiting_approval: "Awaiting approval",
    pending_banner_approval: "Waiting for {approver} to approve the hand-over, then {name} confirms receipt",
    nav_classrooms: "Classrooms",
    cr_eyebrow: "Class assets",
    cr_title: "Classrooms & rooms",
    cr_subtitle: "Class assets belong to the room, not to a teacher. When the teacher changes, hand the room over: the new teacher checks every asset.",
    cr_add: "Add room",
    cr_create_title: "Add a classroom / room",
    cr_save: "Save",
    cr_created: "Room added",
    cr_search: "Search room or teacher…",
    cr_empty: "No rooms found.",
    cr_name: "Room",
    cr_campus: "Campus",
    cr_type: "Type",
    cr_type_kelas: "Classroom",
    cr_type_lab: "Laboratory",
    cr_type_kantor: "Office",
    cr_type_lainnya: "Other",
    cr_responsible: "Responsible teacher",
    cr_none_resp: "— Not set —",
    cr_class_assets: "Class assets",
    cr_personal_assets: "Personal assets",
    cr_value: "Purchase value",
    cr_status: "Status",
    cr_handover_short: "Hand-over {n}/{t} checked",
    cr_discrepancy: "Hand-over discrepancy",
    cr_discrepancy_hint: "Marked missing/damaged by the new teacher. These assets stay with the previous holder until you follow up.",
    cr_still_with: "still with",
    cr_resolve: "Mark resolved",
    cr_resolve_all: "Resolve all",
    cr_resolved: "Discrepancy cleared",
    cr_back: "All rooms",
    cr_handover_btn: "Change responsible teacher",
    cr_handover_title: "Hand-over in progress",
    cr_handover_progress: "{c} of {t} assets checked",
    cr_handover_note: "The change takes effect when all assets are checked. Until then the previous teacher stays responsible.",
    cr_cancel_handover: "Cancel hand-over",
    cr_cancel_confirm: "Cancel this hand-over? Items already checked will be dropped.",
    cr_cancelled: "Hand-over cancelled",
    cr_holding: "Held by",
    cr_held_class: "Class asset",
    cr_held_personal: "Personal (stays with teacher)",
    cr_personal_stays: "personal — stays with teacher",
    cr_no_assets: "No assets in this room.",
    cr_edit: "Edit room",
    cr_edit_title: "Edit room",
    cr_edit_hint: "Renaming also updates the location of every asset in this room.",
    cr_master_hint: "This is the master list of rooms. Asset forms and transfers pick room names from here, so a room is named once. Rename, merge duplicates or delete empty rooms with the icons.",
    cr_delete: "Delete room",
    cr_delete_confirm: "Delete the room \"{name}\"? This only works when no asset is placed in it.",
    cr_deleted: "Room deleted",
    cr_merge_title: "Merge into another room",
    cr_merge_hint: "Use this for a duplicate with a similar name: its assets move to the room you pick, then this room is removed.",
    cr_merge_pick: "Pick the room to keep…",
    cr_merge_btn: "Merge",
    cr_name_taken: "A room named \"{name}\" is already registered. Use Merge below to combine them.",
    cr_registered_like: "Registered rooms that match:",
    cr_merge_into_this: "merge into this",
    cr_merge_confirm: "Move everything from \"{from}\" into \"{to}\" and remove \"{from}\"?",
    cr_merged: "{n} assets moved to {to}",
    room_pick: "Search and pick a room…",
    room_search: "Search room…",
    room_none: "No registered room matches.",
    room_register: "+ Register \"{name}\" as a new room",
    room_ask_admin: "Not in the list? Ask an admin to register it in Classrooms & rooms.",
    room_unregistered: "This room is not in the master list. Pick a registered room.",
    room_registered: "Registered room",
    room_new: "New room name (not in the master list yet).",
    room_similar: "Did you mean:",
    room_manage: "Room names are managed in",
    room_confirm_use: "The room \"{name}\" looks like an existing room: {list}.\n\nOK = use \"{first}\"\nCancel = decide next",
    room_confirm_new: "Create \"{name}\" as a new, separate room?",
    cr_saved: "Room updated",
    cr_make_class: "Make class asset",
    cr_make_personal: "Make personal",
    cr_kind_changed: "{n} asset(s) updated",
    cr_history: "Hand-over history",
    cr_hist_done: "{a} accepted · {d} discrepancy",
    cr_hist_cancelled: "cancelled",
    cr_hist_pending: "in progress",
    bt_title: "Transfer {n} selected asset(s)",
    bt_hint: "All selected assets go to one registered user, who confirms receipt (supervisor in CC).",
    bt_selected: "{n} selected",
    bt_transfer: "Assign / transfer selected",
    bt_room_hint: "Optional. Every selected asset is placed in this registered room. Leave empty to keep their current rooms.",
    bt_clear: "Clear selection",
    pending_banner: "Waiting for {name} to confirm receipt",
    owner_confirm_hint: "Registered users only. They are e-mailed (supervisor in CC) and must confirm before it is recorded under their name.",
    owner_none: "— No owner yet —",
    owner_edit_hint: "To change the holder use Transfer on the asset page.",
    transfer_pending_toast: "Hand-over sent. {name} must confirm receipt.",
    asset_created_pending: "Asset saved. {name} was e-mailed to confirm receipt.",
    transfer_approved: "Transfer approved and applied.",
    transfer_rejected: "Transfer request rejected.",
    request_transfer: "Request transfer",
    transfer_request_hint: "Your request will be sent to an admin for approval before the transfer takes effect.",
    submit_request: "Submit request",
    nav_transfer_requests: "Transfer requests",
    tr_filter_pending: "Pending",
    tr_filter_approved: "Approved",
    tr_filter_rejected: "Rejected",
    tr_filter_all: "All requests",
    tr_empty: "No transfer requests",
    tr_empty_sub: "Requests submitted by staff will appear here for review.",
    tr_my_empty: "You haven't submitted any transfer requests yet.",
    tr_my_empty_sub: "Open an asset and click Transfer to submit a request.",
    tr_my_requests: "My Transfer Requests",
    tr_my_subtitle: "Track the status of transfer requests you have submitted.",
    tr_requested_by: "Requested by",
    tr_approved_by: "Approved by",
    tr_rejected_by: "Rejected by",
    tr_reason: "Reason",
    tr_unassigned: "Unassigned",
    tr_approve: "Approve",
    tr_reject: "Reject",
    tr_reject_title: "Reject transfer request",
    tr_reject_desc: "Optionally provide a reason that will be shown to the requester.",
    tr_reject_reason_placeholder: "Reason for rejection (optional)",
    tr_confirm_reject: "Confirm rejection",

    // Loan requests
    nav_loan_requests: "Loan requests",
    loan_request: "Request loan",
    loan_request_title: "Request asset loan",
    loan_request_hint: "Your request will be sent to an admin for approval.",
    loan_purpose: "Purpose",
    loan_purpose_placeholder: "e.g. Classroom use for science project",
    loan_from: "From",
    loan_until: "Until",
    loan_from_label: "Start date (optional)",
    loan_until_label: "End date (optional)",
    loan_request_submitted: "Loan request submitted for approval.",
    loan_approved: "Loan request approved.",
    loan_rejected: "Loan request rejected.",
    loan_empty: "No loan requests",
    loan_empty_sub: "Requests submitted by staff will appear here for review.",
    loan_my_empty: "You haven't submitted any loan requests yet.",
    loan_my_empty_sub: "Open an asset and click Request loan to submit a request.",
    loan_my_requests: "My Loan Requests",
    loan_my_subtitle: "Track the status of loan requests you have submitted.",
    loan_reject_title: "Reject loan request",
    loan_filter_active: "Active (out)",
    loan_filter_returned: "Returned",
    loan_deliver: "Deliver asset",
    loan_deliver_title: "Record pre-delivery check",
    loan_deliver_hint: "Document the asset condition before handing it over to the borrower.",
    loan_return: "Record return",
    loan_return_title: "Record asset return",
    loan_return_hint: "Document the asset condition after it has been returned.",
    loan_condition: "Condition",
    loan_condition_note: "Condition note (optional)",
    loan_condition_note_placeholder: "Any visible damage, notes, or observations…",
    loan_condition_photo: "Condition photo (optional)",
    loan_condition_photo_hint: "Click to upload a photo",
    loan_cond_good: "Good",
    loan_cond_trouble: "Has issues",
    loan_cond_broken: "Broken",
    loan_cond_missing: "Missing",
    loan_confirm_deliver: "Confirm delivery",
    loan_confirm_return: "Confirm return",
    loan_delivered_ok: "Asset delivered — loan is now active.",
    loan_returned_ok: "Return recorded.",
    loan_pre_check: "Pre-delivery check",
    loan_post_check: "Return check",
    loan_delivered_at: "Delivered",
    loan_returned_at: "Returned",

    export_excel: "Export to Excel",
    exporting: "Exporting…",

    // Bulk import
    import_assets: "Import assets",
    import_modal_title: "Bulk import assets",
    import_step_upload: "Upload file",
    import_step_preview: "Preview",
    import_step_done: "Done",
    import_download_template: "Download CSV template",
    import_download_template_xlsx: "Download Excel template",
    import_drop_hint: "Drop a CSV or Excel (.xlsx) file here, or click to browse",
    import_file_selected: "File selected",
    import_preview_btn: "Preview import",
    import_rows_found: "rows found",
    import_valid: "valid",
    import_invalid: "with errors",
    import_confirm_btn: "Import valid rows",
    import_importing: "Importing…",
    import_done_title: "Import complete",
    import_done_msg: "{{imported}} assets imported, {{skipped}} skipped.",
    import_pending_note: "{n} assets were sent to their owners for confirmation by e-mail.",
    import_owner_ignored: "{n} owner names were not registered users and were left as \"No owner yet\". Add them under Users, then assign.",
    import_done_close: "Close",
    import_col_row: "Row",
    import_col_name: "Name",
    import_col_tag: "Tag",
    import_col_category: "Category",
    import_col_campus: "Campus",
    import_col_status: "Status",
    import_col_errors: "Errors",
    import_no_valid: "No valid rows to import.",
    import_file_required: "Please select a file first.",

    fault_reported_ok: "Fault reported",
    asset_load_error: "Failed to load asset",
    saving: "Saving…",
    save_changes: "Save changes",
    create_asset: "Create asset",
    cancel: "Cancel",

    // Asset detail
    back_to_assets: "Back to assets",
    quick_facts: "Quick facts",
    assigned_to: "Assigned to",
    purchased: "Purchased",
    warranty_until: "Warranty until",
    depreciation: "Depreciation",
    annual_dep: "Annual depreciation",
    accumulated: "Accumulated",
    current_book_value: "Current book value",
    report_fault: "Report fault",
    report_a_fault: "Report a fault",
    severity: "Severity",
    sev_low: "Low",
    sev_medium: "Medium",
    sev_high: "High",
    submit: "Submit",
    transfer: "Transfer",
    transfer_ownership: "Transfer ownership",
    new_owner_label: "New owner / location",
    send_invitation: "Send invitation",
    reset_password: "Reset password",
    invite_confirm: "Send {name} ({email}) an invitation e-mail with a link to create their own password? Their current password stops working until they do.",
    reset_confirm: "Send {name} ({email}) a password reset link? Their current password keeps working until they set a new one.",
    invite_sent: "Invitation sent to {email}",
    reset_sent: "Reset link sent to {email}",
    link_send_failed: "The e-mail could not be sent.",
    link_no_email: "E-mail is not configured.",
    link_copied: "The link was copied; share it with the user manually.",
    sp_title_invite: "Create your password",
    sp_title_reset: "Set a new password",
    sp_new: "New password",
    sp_confirm: "Confirm password",
    sp_save: "Save password",
    sp_too_short: "Password must be at least 6 characters.",
    sp_mismatch: "Passwords do not match.",
    sp_invalid_title: "Link not valid",
    sp_invalid_sub: "This link has expired or was already used. Request a new one.",
    sp_request_new: "Request a new link",
    sp_done_title: "Password saved",
    sp_done_sub: "You can now sign in with your new password. Redirecting…",
    fp_link: "Forgot password?",
    fp_title: "Forgot your password?",
    fp_sub: "Enter your account e-mail and we will send you a link to set a new password.",
    fp_sent: "If that e-mail is registered, a reset link is on its way. Check your inbox (and spam).",
    fp_send: "Send reset link",
    fp_back: "Back to sign in",
    close: "Close",
    bulk_add_users: "Bulk add",
    us_search: "Search name, email, employee ID, department…",
    us_no_match: "No users match your search.",
    bu_title: "Add users in bulk",
    bu_hint: "Upload a CSV or Excel file with one user per row (columns: name, email, role, department, campus, supervisor_name, supervisor, employee_id, password). Only name and email are required. Leave password blank to generate one.",
    bu_invite: "E-mail each new user their login details (e-mail + temporary password)",
    bu_skip_note: "Rows with errors are skipped; only valid rows are created.",
    bu_import_btn: "Create {n} users",
    bu_created: "users created",
    bu_skipped: "skipped",
    bu_invited: "{n} invitation e-mails sent",
    bu_no_email: "E-mail is not configured, so no invitations were sent.",
    bu_pw_warning: "Passwords are shown only now. Download or share them before closing; users should change theirs after first login.",
    bu_auto: "auto",
    bu_download: "Download login list (CSV)",
    new_owner_placeholder: "Search a registered user…",
    transfer_user_required: "Pick a registered user from the list. Add them under Users first if they are missing.",
    note: "Note",
    confirm_transfer: "Confirm transfer",
    edit: "Edit",
    tab_overview: "Overview",
    tab_ownership: "Ownership",
    tab_faults: "Faults",
    tab_documents: "Documents",
    cat_label: "Category",
    created_label: "Created",
    no_ownership: "No ownership records.",
    transferred_to: "Transferred to",
    no_faults: "No fault reports.",
    no_documents: "No documents attached.",
    asset_not_found: "Asset not found.",
    delete_asset_confirm: "Delete this asset? This cannot be undone.",
    asset_deleted: "Asset deleted",

    // Dashboard
    overview: "Overview",
    asset_dashboard: "Asset dashboard",
    total_assets: "Total assets",
    categories: "categories",
    acc_depreciation: "Accumulated depreciation",
    straight_line: "Straight-line method",
    open_faults: "Open faults",
    compliance_overdue: "compliance overdue",
    forecast: "Forecast",
    book_value_6yr: "Book value, 6-year horizon",
    action_required: "Action required",
    warranty_alerts: "Warranty alerts",
    all_warranties_ok: "All warranties in good standing.",
    expired: "Expired",
    expires: "Expires",
    recent: "Recent",
    fault_reports: "Fault reports",
    view_all: "View all →",
    no_faults_reported: "No faults reported.",
    by_category: "By category",
    due_30: "Due in 30 days",
    of_purchased: "Of",
    purchased_label: "purchased",

    // Faults
    maintenance: "Maintenance",
    all_faults: "All faults",
    filter_open: "Open",
    filter_in_progress: "In progress",
    filter_resolved: "Resolved",
    no_fault_reports: "No fault reports",
    faults_sub: "Reports will appear here when staff submit them.",
    reported_by: "Reported by",
    sev_label: "Severity",
    mark_in_progress: "Mark in progress",
    resolve: "Resolve",
    resolve_fault: "Resolve fault",
    resolution_note: "Resolution note (optional)…",
    mark_resolved: "Mark resolved",

    // Compliance
    regulatory: "Regulatory",
    compliance_checks: "Compliance checks",
    add_check: "Add check",
    new_check: "New compliance check",
    title_label: "Title",
    cat_safety: "Safety",
    cat_inspection: "Inspection",
    cat_certification: "Certification",
    cat_audit: "Audit",
    frequency: "Frequency",
    freq_once: "Once",
    freq_monthly: "Monthly",
    freq_quarterly: "Quarterly",
    freq_annual: "Annual",
    due_date: "Due date",
    create: "Create",
    no_checks: "No compliance checks yet",
    pending: "Pending",
    completed: "Completed",
    mark_complete: "Mark complete",
    overdue: "Overdue",

    // Users
    access_control: "Access control",
    team_users: "Team & users",
    add_user: "Add user",
    create_user: "Create user",
    role: "Role",
    staff: "Staff",
    unit_scope: "School units handled",
    unit_scope_hint: "Leave all unticked for every unit. When units are ticked, this Admin can only assign assets of those units and is only copied on their approvals.",
    admin: "Resources Admin",
    staff_view_only: "View only. You can report faults and request transfers only for assets assigned to you, and borrow only shared assets that nobody holds personally.",
    super_admin: "Super Admin",
    ict_admin: "ICT Admin",
    campus_admin: "Campus Admin",
    leader: "Leader (view only)",
    col_name: "Name",
    col_joined: "Joined",
    col_actions: "Actions",
    cant_delete_self: "You can't delete yourself",

    // Reports
    analytics: "Analytics",
    reports: "Reports",
    reports_soon: "Reports coming soon",
    reports_sub: "Asset summaries, depreciation reports and export tools will appear here.",
    report_download_xlsx: "Download (.xlsx)",
    report_downloading: "Downloading…",
    report_asset_inventory: "Asset Inventory",
    report_asset_inventory_desc: "Full list of all assets with category, campus, room, status, owner, and current book value.",
    report_depreciation: "Depreciation Schedule",
    report_depreciation_desc: "Per-asset depreciation breakdown — annual, accumulated, and current book value.",
    report_faults: "Fault Report",
    report_faults_desc: "All fault reports with status, severity, reporter, and resolution notes.",
    report_compliance: "Compliance Register",
    report_compliance_desc: "All compliance checks with due dates, status, and category.",
    report_fully_depreciated: "Fully Depreciated Assets",
    report_fully_depreciated_desc: "Assets still in use that have reached the end of their useful life — candidates for review or replacement.",
    life_hint: "Suggested for this category: {n} years. You can change it.",
    report_ownership: "Ownership History",
    report_ownership_desc: "Complete audit trail of asset ownership changes across both campuses.",

    // Activity logs
    audit: "Audit",
    activity_logs: "Activity Logs",
    logs_soon: "Activity logs coming soon",
    logs_sub: "A full audit trail of all asset changes, transfers and user actions will appear here.",
    log_all: "All events",
    log_all_actions: "All actions",
    log_all_entities: "All entities",
    log_asset_created: "Asset registered",
    log_ownership_transfer: "Ownership transfer",
    log_fault_reported: "Fault reported",
    log_fault_resolved: "Fault resolved",
    log_compliance_added: "Compliance added",
    log_user_created: "User created",
    log_by: "by",
    log_to: "→",
    log_load_more: "Load more",
    log_no_events: "No activity yet.",
    log_campus: "Campus",
    log_col_when: "When",
    log_col_action: "Action",
    log_col_entity: "Entity",
    log_col_target: "Target",
    log_col_user: "User",
    log_col_details: "Details",

    // Help
    support: "Support",
    help_guide: "User guide",
    documentation: "Documentation",
    help_subtitle: "A quick reference for everyday tasks in the YPJ School Asset Registry. Click any topic in the contents to jump to the section.",
    help_toc_label: "On this page",
    help_need_help_title: "Need more help?",
    help_need_help_body: "Reach out to your school administrator or the operations team for account changes and policy questions.",

    // Section titles
    help_s1_title: "Getting started",
    help_s2_title: "Reading the dashboard",
    help_s3_title: "Registering a new asset",
    help_s4_title: "Finding & filtering assets",
    help_s5_title: "Transferring ownership",
    help_s6_title: "Reporting & resolving faults",
    help_s7_title: "Tracking compliance",
    help_s8_title: "Warranty & depreciation",
    help_s9_title: "Managing users (admin)",
    help_s10_title: "Photos & PDF attachments",

    // S1 — Getting started
    help_s1_intro: "Welcome to the YPJ School Asset Registry. The system gives every staff member a single, real-time view of the school's assets — from laptops and projectors to furniture and vehicles — and handles hand-overs, equipment loans, lab bookings and student BYOD approvals. The first time you sign in you must read and confirm the school policies (see \"Policies and your first sign-in\").",
    help_s1_roles_heading: "Your role decides what you can do:",
    help_s1_role_admin: "Super Admin / Admin — manage assets, users and compliance. The Super Admin can also manage Admin accounts and everything in the loan module.",
    help_s1_role_staff: "Staff (teachers) — view assets of your campus, confirm hand-overs, report faults, borrow equipment, book labs and open BYOD requests for your students.",
    help_s1_role_ict: "ICT Admin — the person in charge (PIC) of ICT equipment on ONE campus: confirms loans, hands over and takes back equipment, manages carts, labs, fixed schedules and BYOD approvals.",
    help_s1_role_leader: "Leader — read-only view of everything, including loan dashboards and reports. A leader cannot create or change anything.",

    // S2 — Dashboard
    help_s2_intro: "The dashboard is the home page after login. It shows four KPI cards at the top:",
    help_s2_kpi1: "Total Assets — count of every active record.",
    help_s2_kpi2: "Current Book Value — what your inventory is worth today, after depreciation.",
    help_s2_kpi3: "Accumulated Depreciation — how much value has been written off (straight-line method).",
    help_s2_kpi4: "Open Faults — fault reports that have not yet been resolved.",
    help_s2_outro: "The chart shows a 6-year forecast of book value. The right panel lists assets whose warranty is expiring (or already expired) within 60 days — click any item to open it.",

    // S3 — Register asset
    help_s3_step1: "Click Assets in the sidebar, then Add asset.",
    help_s3_step2: "Fill in Section 01 — Basic Information: name, asset tag, category, location, status, and the initial owner.",
    help_s3_step3: "In Section 02 — Financials & Warranty, enter the purchase price, purchase date, useful life (in years) and warranty end date. Depreciation is calculated automatically using the straight-line method.",
    help_s3_step4: "In Section 03 — Photo & Documents, click the photo box to upload an image of the asset, and the document box to attach PDFs (invoices, manuals, certificates).",
    help_s3_step5: "Click Create asset.",

    // S4 — Find & filter
    help_s4_intro: "The Assets page supports advanced filtering:",
    help_s4_tip1: "The search box matches asset name, tag, or serial number (live, as you type).",
    help_s4_tip2: "Use the Category dropdown to filter by IT Equipment, Furniture, Lab, Vehicles, etc.",
    help_s4_tip3: "Use the Campus dropdown to show only one campus at a time.",
    help_s4_tip4: "Use the Status dropdown to show only Active, In Repair, Retired or Lost items.",
    help_s4_outro: "Click any row to open the full asset detail page.",

    // S5 — Transfer
    help_s5_intro: "To give an asset to someone else (or to move it between owners), an Admin uses Transfer on the asset page, or the bulk hand-over on the Users / Classrooms pages:",
    help_s5_step1: "Open the asset detail page and click Transfer (or select several assets and choose bulk hand-over).",
    help_s5_step2: "Choose the recipient. The recipient must be a registered user.",
    help_s5_step3: "The recipient gets an e-mail and sees the hand-over under My Assets. The asset only changes owner after they check it and confirm receipt; they can also reject it with a reason.",
    help_s5_step4: "A recipient who has not confirmed the school policies cannot receive assets: confirm them first.",
    help_s5_note: "Classroom hand-overs work the same way: the responsible teacher checks every item in the room and confirms or reports differences. The full ownership trail stays on the Ownership tab.",

    // S6 — Faults
    help_s6_intro: "Anyone can report a fault from an asset's detail page (Report fault button) or from the Faults page.",
    help_s6_workflow_heading: "Each fault has a status workflow:",
    help_s6_status1: "Open — newly reported.",
    help_s6_status2: "In Progress — someone has started work on it.",
    help_s6_status3: "Resolved — fixed; a resolution note can be added.",
    help_s6_actions: "Faults page actions: Mark in progress moves an Open fault forward; Resolve closes it with an optional note.",

    // S7 — Compliance
    help_s7_intro: "Use the Compliance section for recurring regulatory requirements — fire-extinguisher recertifications, school-bus safety inspections, lab calibrations, audits, etc.",
    help_s7_tip1: "Admin creates checks with a title, category, due date and frequency (Once, Monthly, Quarterly, Annual).",
    help_s7_tip2: "Items are grouped by status: Overdue, Pending, Completed.",
    help_s7_tip3: "Overdue items are flagged automatically on the dashboard for action.",

    // S8 — Depreciation
    help_s8_warranty: "Warranty alerts appear on the dashboard for any asset whose warranty has expired or will expire within 60 days. Click an alert to open the asset and plan a renewal or replacement.",
    help_s8_dep_intro: "Depreciation is calculated automatically using the straight-line method:",
    help_s8_outro: "You'll see the live numbers — annual, accumulated, and current book value — on every asset's detail page.",

    // S9 — Users
    help_s9_intro: "Admins can invite unlimited users from the Users page:",
    help_s9_step1: "Click Add user.",
    help_s9_step2: "Enter name, email, role (Staff, ICT Admin, Leader, Admin or Super Admin), campus, department and WhatsApp number. ICT Admins must have a campus. You can also import many users from a spreadsheet.",
    help_s9_step3: "Click Create. The user receives a link to set their own password. Their first sign-in shows the policies they must confirm.",
    help_s9_note: "To remove a user, click the trash icon on their row. You cannot delete your own account.",

    // S10 — Attachments
    help_s10_intro: "Each asset can have one photo and unlimited PDF/document attachments. Files are stored securely in cloud object storage and only authenticated users can access them.",
    help_s10_tip1: "Add — upload during Add/Edit asset (Section 03).",
    help_s10_tip2: "View — photo appears in the Asset Detail header. Documents appear under the Documents tab.",
    help_s10_tip3: "Download — click the download icon next to any document.",

    // Help: policies, loans, schedule, QR, BYOD
    help_s11_title: "Policies and your first sign-in",
    help_s11_intro: "The first time you sign in (and again whenever the policies change), a window asks you to read all school policies and confirm them. You cannot use the system before you do.",
    help_s11_step1: "Scroll to the end of the policies — the confirmation section unlocks only then.",
    help_s11_step2: "Tick the three statements: you have read the rules, you will comply, and you accept the sanctions.",
    help_s11_step3: "Type your full name exactly as in your account, then click \"I confirm and sign\". The date, time, policy version and device are recorded as your electronic signature.",
    help_s11_note: "Without this confirmation you cannot borrow equipment or be assigned assets. Sanctions include loss of access to school assets and having to repair, replace or compensate an asset that is damaged or lost through negligence. You can re-read the policies any time under Policies; Admins can see who has confirmed there and export the list.",
    help_s12_title: "Borrowing equipment",
    help_s12_intro: "Use Loan requests to borrow ICT and media equipment. Open the Borrow tab:",
    help_s12_step1: "For one specific item (camera, microphone, …): find it and click Request loan. Choose the start and end time, the purpose, and accept the responsibility statement.",
    help_s12_step2: "For laptops or iPads outside a fixed schedule: use \"Borrow laptops\" / \"Borrow iPads\" and only enter HOW MANY you need and when. You may borrow more than one device. The ICT Admin chooses which devices to lend from those still free. The red/green box under the times shows how many are free for that window; if it says 0, a line below explains why (registered, on loan, or held by a cart's class schedule). Admin accounts without their own campus first choose the campus.",
    help_s12_step3: "The ICT Admin confirms the request (take-home requests also need your supervisor first). You get an e-mail with the decision. Laptops and iPads stay on campus.",
    help_s12_step4: "Collect the equipment at the ICT room. The ICT Admin records the condition, the accessories checklist and a before-photo. Hand-over and return can be done from the Scan loans page.",
    help_s12_step5: "Return it on time. A reminder is e-mailed before the return date; loans past their end time are marked Overdue and block new requests until returned.",
    help_s12_step6: "At return the ICT Admin checks the condition again with an after-photo. Damage or loss opens a fault automatically.",
    help_s12_note: "Rules: request at least 1 day ahead and at most 14 days ahead (defaults, ICT can change them), not on school holidays, and only for your own campus. Photos are shrunk automatically to at most 50 KB each: one before and one after per device. Your requests and their status are under My loans.",
    help_s12_ict: "ICT Admin: open a request under To confirm / handle. For laptop/iPad requests choose exactly as many free devices as you approve (only devices that are really free for that time are listed). Approval reserves them; at hand-over you can leave some out or swap one for another free device. Set the maximum devices per request under Schedule & labs › Schedule setup.",
    help_s13_title: "Schedule, carts and labs",
    help_s13_intro: "Schedule & labs shows a weekly calendar of laptop carts, iPad carts and computer labs by lesson period. Green means units are free, red means fully used. Fixed class schedules always come first.",
    help_s13_tip1: "Teachers: click a free slot to request extra time outside the fixed schedule (units and periods).",
    help_s13_tip2: "ICT Admin: in Schedule setup, add carts and labs and their units, lesson periods, school holidays, fixed class schedules, and pair each tablet or laptop with a student for the semester.",
    help_s13_tip3: "For a fixed-schedule session, the ICT Admin starts the hand-over from the calendar: the whole cart is handed over at once, with exceptions listed and one group photo.",
    help_s13_tip4: "Loans outside the schedule follow the calendar: while a class session holds a cart, its units show as \"In use (scheduled)\" in the loan list and the scan page, and a single-unit loan can only use what the schedule leaves free. A unit lent on its own also takes one place in its cart.",
    help_s14_title: "Barcode labels and scanning",
    help_s14_intro: "Every asset can carry a barcode label. ICT Admins and Admins print labels from Scan loans › Print barcode labels (two long bar rows per line, easy to scan even from a computer screen) and stick them on the equipment. There are two scan pages: Scan loans and Scan asset. Both read barcodes and QR codes with the camera or a USB barcode scanner, and accept a typed asset code or serial number.",
    help_s14_tip1: "Scan loans: shows the asset's status. For a unit lent on its own it goes straight to hand-over or return. For a cart unit during a class session it shows the session (class, teacher, time) and the button \"Hand over scheduled session\", which opens the check-out of that session.",
    help_s14_tip2: "The status \"In use (scheduled)\" means a fixed schedule or booking holds the cart right now, and the line \"Cart G: 20 / 22 units in use by the schedule\" shows how much. The \"Borrow this asset\" button only appears when the asset is available.",
    help_s14_tip3: "Scan asset: opens a registered asset (view or edit). When the code is not registered, \"Register as new asset\" opens the new-asset form with the code already filled in.",
    help_s14_tip4: "If the camera is not available, type the asset code (for example YPJ-KAM-005) or the serial number. Spacing and capital letters do not matter.",
    help_s14_tip5: "For a cart or lab, scan the units one by one to tick them off during hand-over or return.",
    help_s14_tip6: "A teacher borrowing several laptops / iPads outside the schedule: on Scan loans tick \"Lend several units at once\", scan each unit into the basket, choose the borrower and return time, then \"Create one loan\". All units form ONE loan. Add one group photo of the units to hand them all over in the same step (recorded as good condition); without a photo, finish the hand-over (condition, photo) on the loan page. Only available laptops / iPads can be added, and not mixed.",
    help_s15_title: "Student BYOD (own device)",
    help_s15_intro: "Students may bring their own laptop, iPad or tablet (not phones) for a project, within a period set by the supervising teacher. The approval order is: parent, then teacher, then ICT. Open Student BYOD.",
    help_s15_step1: "Teacher: click New BYOD project. Enter the project, the dates (at most about 3 months), the allowed hours and add the students with a parent e-mail or WhatsApp number.",
    help_s15_step2: "Each parent receives a one-time link (valid 7 days), reads the terms, enters the device details and MAC address, and signs with their finger. No account is needed. If a message did not arrive, copy the link or use Send link again.",
    help_s15_step3: "After the parent signs, the teacher signs in the app (type your name and draw your signature).",
    help_s15_step4: "The campus ICT Admin checks the devices, can correct a MAC address, and approves or rejects. After approval, add the MAC addresses to the school WiFi (export them with Export active devices).",
    help_s15_note: "Maximum 2 devices per student and a MAC address can only be registered once. The teacher can request one extension (ICT must approve). ICT can revoke access at any time. Teacher and ICT are reminded 3 days before it ends. The signed form can be printed or saved as PDF from the request page.",
    help_fig_hero: "YPJ Assets runs in any browser: laptop, tablet and phone.",
    help_fig_policy: "The policy window you confirm on first sign-in.",
    help_fig_dashboard: "The dashboard: total assets, book value, depreciation and open faults.",
    help_fig_asset_new: "The Add asset form: identity, financials and photo & documents.",
    help_fig_assets: "The asset list with search and filters.",
    help_fig_asset_detail: "Asset page with Report fault, Transfer and Edit.",
    help_fig_my_assets: "My Assets on a phone: check the item and tap Accept or Reject.",
    help_fig_borrow: "Borrow tab: pick equipment, or request N laptops / iPads.",
    help_fig_borrow_dialog: "Request laptops: only how many and when.",
    help_fig_loan_detail: "ICT Admin confirms the request and picks the free devices.",
    help_fig_schedule: "Weekly calendar: green = free units, red = fully used.",
    help_fig_scan: "Scan loans: scan the barcode or type the asset code.",
    help_fig_byod_sign: "The parent signs on a phone with a finger, no account needed.",
    help_fig_byod_detail: "The request page shows the approval flow: parent, teacher, ICT.",
    help_fig_faults: "Faults list with status and actions.",
    help_fig_compliance: "Compliance checks with due dates; overdue items are flagged.",
    help_fig_users: "Team & users: roles, campus and bulk import.",
    help_fig_zoom: "Click an image to enlarge",

    // Policies page
    pol_section: "Governance",
    pol_title: "Policies & Procedures",
    pol_subtitle: "Official YPJ school policies governing staff conduct, asset use, and data management.",
    pol_toc: "On this page",
    pol_effective: "Effective",
    pol_effective_date: "Version 2026.1 — Academic Year 2026–2027. Reviewed annually by the YPJ School Administration. Every user must re-confirm the policies whenever a new version is published.",
    pol_questions: "Questions?",
    pol_questions_body: "Contact your school administrator or the ICT department for clarifications on any policy.",

    pol_tag_ict: "ICT",
    pol_tag_asset: "Asset Management",
    pol_tag_data: "Data & Privacy",
    pol_tag_admin: "Administration",

    // RUP
    pol_rup_title: "Responsible Use Policy (RUP) — ICT Resources",
    pol_rup_purpose_h: "Overview",
    pol_rup_purpose: "The following summarises the Responsible Use Policy for Information and Communication Technology (ICT) resources. Please use this as a guide for acceptable use of ICT systems and the Internet at school and off campus.",
    pol_rup_scope_h: "Scope of YPJ Technology Resources",
    pol_rup_scope: "All YPJ technology resources — desktops, laptops, iPads, photocopiers, printers, applications (apps), email, Internet, Intranet, SharePoint, network resources, audio/visual equipment, and related technology — belong to PTFI & YPJ and are loaned to me as an employee.",
    pol_rup_acceptable_h: "Acceptable Use",
    pol_rup_acceptable: "Use of YPJ technology is for educational purposes and YPJ-related school work only.||Use of YPJ technology is a privilege; care for the equipment is my responsibility.||I will keep YPJ technology resources secure at all times and will not lend them to friends or family members.||I am responsible for the backup and recovery of my own data stored on YPJ technology resources.||All information copied and used will be properly attributed with author, source, publication date, and/or website link.",
    pol_rup_prohibited_h: "Prohibited Activities",
    pol_rup_prohibited: "I will not install software, remove programs, or use any configuration method to change the original settings of equipment.||I will not remove YPJ technology resources from the work location (unless given written permission by my Supervisor).||I will not disclose my login password to any other person, in accordance with FMI MIS policy.||Viewing or distributing pornographic, obscene, or offensive material will not be tolerated.||All forms of cyberbullying (harassing, teasing, intimidating, threatening, or sending/posting inappropriate messages via email, chat, text, WhatsApp, images, or websites) are unacceptable.||Avoid chain mail and only send emails to large groups when necessary.||Downloading and streaming large files for non-instructional use is prohibited.||YPJ technology resources cannot be used for personal gain or political activities.||I will not take photos, videos, or audio recordings of others without their consent.||I will not distribute recordings of others via email, SMS, WhatsApp, social media, or any other platform without their consent.",
    pol_rup_breach_h: "Consequences of Inappropriate Use",
    pol_rup_breach: "Violations of this policy may result in loss of internet and/or computer access privileges. Serious violations may lead to suspension or dismissal. I will pay an appropriate amount (up to full replacement cost) if a loaned laptop or iPad requires repair or replacement due to negligence, loss, theft, or accident.",

    // Asset Care
    pol_care_title: "Asset Care & Maintenance Policy",
    pol_care_purpose_h: "Purpose",
    pol_care_purpose: "This policy ensures all school assets are properly cared for, maintained in good condition, and any issues are promptly reported to preserve the value of YPJ's inventory.",
    pol_care_obligations_h: "Staff Obligations",
    pol_care_obligations: "Handle all assigned assets with reasonable care and in accordance with manufacturer guidelines.||Store assets securely when not in use and protect them from damage, theft, or loss.||Report any damage, malfunction, or deterioration immediately through the Faults page in this system.||Do not attempt unauthorised repairs or modifications to any school asset.||Return assets to the correct location after use.",
    pol_care_damage_h: "Damage & Loss",
    pol_care_damage: "Accidental damage must be reported within 24 hours through the Faults page. Damage or loss resulting from negligence, misuse or failure to report may result in the staff member being held financially responsible for repair or full replacement costs, and/or losing access to school assets, as determined by the school administration (see Sanctions & Liability).",
    pol_care_reporting_h: "Reporting",
    pol_care_reporting: "All faults must be logged in the School Assets Management system via the Report Fault button on the relevant asset's page. This creates an auditable record and enables the maintenance team to respond promptly.",

    // Loan & Transfer
    pol_loan_title: "Asset Loan, Booking & Transfer Policy",
    pol_loan_purpose_h: "Purpose",
    pol_loan_purpose: "This policy governs the borrowing, scheduling and transfer of school assets between staff members and locations, ensuring proper accountability and traceability at all times. ICT and media equipment is handled through the Loans module; carts, labs and rooms are booked through the Schedule.",
    pol_loan_eligibility_h: "Eligibility",
    pol_loan_eligibility: "All permanent and contract staff are eligible to request asset loans, bookings or transfers.||Requests must be made through the School Assets Management system, not by phone, message or verbal agreement.||Assets may only be used for school-related purposes.||Staff may only request assets within their assigned campus. Equipment may leave campus only if the loan rules for that category allow it and the ICT Admin has confirmed it.||Requests must be submitted at least the minimum notice period ahead and no further ahead than the maximum advance period set for the category (default: H-1 to H-14).",
    pol_loan_process_h: "Request Process",
    pol_loan_process: "Open the asset (or the cart, lab or room) in the system and submit a loan, booking or transfer request with a clear purpose and dates/periods.||The system checks availability and conflicts. The request is then confirmed by your supervisor where required and by the ICT Admin (PIC) of the campus for ICT categories.||At hand-over the ICT Admin records the asset condition, the accessories checklist and a photo; you are expected to check the asset and report any difference immediately.||Hand-over and return can be done by scanning the QR label on the asset.||Return the asset by the agreed end time. A reminder e-mail is sent before the return date; loans that pass the end time are marked Overdue.||At return the ICT Admin checks the condition and accessories again and records it with a photo. The loan is only complete after this check.",
    pol_loan_return_h: "Return & Accountability",
    pol_loan_return: "Assets must be returned in the same condition as received, with all accessories. Late returns must be communicated to the administrator in advance. Overdue loans are flagged in the system and may block further requests. The condition and photo recorded at hand-over and return are the reference used to decide responsibility for any damage or loss. All times in the system use WIT (UTC+9).",

    // Data & Privacy
    pol_privacy_title: "Data Protection & Privacy Policy",
    pol_privacy_purpose_h: "Purpose",
    pol_privacy_purpose: "YPJ is committed to protecting the personal data of staff, students, and parents. This policy outlines how data within the School Assets Management system is collected, stored, and used.",
    pol_privacy_principles_h: "Key Principles",
    pol_privacy_principles: "Data is collected for legitimate school management purposes only.||Access to the system is restricted to authorised staff with valid credentials.||Staff must not share login credentials or access the accounts of others.||System data must not be exported, shared, or distributed outside official school channels.||YPJ reserves the right to monitor system activity for security and compliance purposes.",
    pol_privacy_access_h: "Access Control",
    pol_privacy_access: "Admin users have full access to all records. Staff users may only view and act on assets within their assigned campus. All system actions are logged for audit purposes.",
    pol_privacy_breach_h: "Data Breach",
    pol_privacy_breach: "Any suspected data breach, unauthorised access, or security incident must be reported immediately to the school administrator and the ICT department. Do not attempt to investigate or resolve a breach independently.",

    // Inventory Management
    pol_inv_title: "Inventory Management Policy",
    pol_inv_purpose_h: "Purpose",
    pol_inv_purpose: "This policy ensures the School Assets Management system remains an accurate, up-to-date record of all YPJ assets, supporting sound financial management and accountability.",
    pol_inv_register_h: "Asset Registration Requirements",
    pol_inv_register: "All new assets must be registered in the system before being put into service.||Each asset must have a unique asset tag, category, campus, and assigned owner or location.||Financial information (purchase price, date, useful life) must be recorded accurately to support depreciation calculations.||Photos and supporting documents (invoices, warranties) should be attached where available.||Assets should carry a QR label so they can be scanned for hand-over, return and audits.",
    pol_inv_audit_h: "Periodic Audits",
    pol_inv_audit: "The school administration will conduct a physical asset audit at least once per academic year. Staff are required to cooperate fully, confirm the location and condition of assets assigned to them (including when an asset is handed over to them), and report any discrepancies immediately.",
    pol_inv_disposal_h: "Disposal & Retirement",
    pol_inv_disposal: "Assets that are no longer serviceable must be updated to Retired status in the system by an admin user. Physical disposal must follow YPJ and PTFI asset disposal procedures and must not be undertaken without written approval from the school principal.",

    // Sanctions & Liability
    pol_sanction_title: "Sanctions & Liability Policy",
    pol_tag_sanction: "Sanctions",
    pol_sanction_purpose_h: "Purpose",
    pol_sanction_purpose: "This policy sets out the consequences when a user breaches the policies above or when a school asset in their care is damaged or lost. By confirming the policies in this system, every user accepts these consequences.",
    pol_sanction_access_h: "Loss of Access",
    pol_sanction_access: "Breach of any policy, repeated late returns, unreported damage or loss, or misuse of an asset may lead to a warning, temporary suspension, or permanent loss of the right to borrow, book or be assigned school assets.||Access to the system and to ICT resources may be restricted while a case is being reviewed.||Serious or repeated breaches may be referred to the school principal and may lead to disciplinary action, including suspension or dismissal.",
    pol_sanction_liability_h: "Repair, Replacement & Compensation",
    pol_sanction_liability: "If an asset in your care or on loan to you is damaged, lost or stolen because of negligence, misuse, or failure to follow these policies, you agree to pay for its repair, or to replace it with an equivalent asset, or to pay the replacement value up to the full replacement cost, as determined by the school administration.||Accidental damage reported on time is assessed case by case.||The conditions, photos and accessories recorded at hand-over and return, and the activity logs, are accepted as evidence.",
    pol_sanction_process_h: "Process",
    pol_sanction_process: "The administration reviews the facts and gives you an opportunity to explain before a final decision is made.||Decisions are recorded in the system. Any amount owed is settled according to YPJ and PTFI procedures.",
    pol_sanction_esign_h: "Electronic Confirmation",
    pol_sanction_esign: "Your electronic confirmation in this system (typed full name, date and time, version of the policies and device information) is recorded as your signed acknowledgement and has the same effect as a written statement of agreement. You must re-confirm whenever a new version is published.",

    // Policy acknowledgement
    polack_title: "Welcome — please read and confirm the school asset policies",
    polack_intro: "Before you use the School Assets Management system you must read all the policies below and confirm that you will follow them. This confirmation is recorded as your electronic signature.",
    polack_scroll_hint: "Scroll to the end of the policies to unlock the confirmation.",
    polack_scrolled: "You have reached the end of the policies.",
    polack_summary_h: "By confirming, you agree that:",
    polack_s1: "I have carefully read and understood all the policies and rules for using school assets.",
    polack_s2: "I will comply with every rule on the use, loan, care and return of school assets.",
    polack_s3: "I accept the sanctions: loss of my access to school assets, and repairing, replacing or compensating any asset that is damaged or lost through my negligence or failure to follow the policies.",
    polack_name_label: "Sign by typing your full name",
    polack_name_hint: "Must match your account name:",
    polack_name_mismatch: "The name does not match your account name.",
    polack_submit: "I confirm and sign",
    polack_submitting: "Saving…",
    polack_footer: "Your confirmation is stored with the date and time, policy version, and device information.",
    polack_saved: "Thank you. Your confirmation has been recorded.",
    polack_failed: "Could not save your confirmation. Please try again.",
    polack_you_signed: "You confirmed these policies on",
    polack_admin_title: "Policy confirmations",
    polack_admin_signed: "users have confirmed",
    polack_admin_pending: "users have not confirmed yet",
    polack_export: "Export Excel",
    polack_download_failed: "Download failed.",

    // Loans module
    ln_kicker: "Equipment loans",
    ln_title: "ICT & Media loans",
    ln_subtitle: "Borrow laptops, cameras, instruments and other equipment. Every request is checked against availability, confirmed by the ICT Admin and recorded with photos at hand-over and return.",
    ln_tab_borrow: "Borrow",
    ln_tab_mine: "My loans",
    ln_tab_manage: "To confirm / handle",
    ln_tab_all: "All loans",
    ln_tab_loans: "Loans",
    ln_search: "Search name, tag, brand…",
    ln_all_categories: "All categories",
    ln_all_statuses: "All statuses",
    ln_no_borrowable: "No borrowable equipment yet. The ICT Admin can enable it on each asset's Loans tab.",
    ln_request: "Request loan",
    ln_request_title: "Loan request",
    ln_submit: "Submit request",
    ln_submitted: "Request submitted:",
    ln_saved: "Saved",
    ln_start: "Start",
    ln_end: "End",
    ln_purpose: "Purpose",
    ln_class: "Class / group",
    ln_subject: "Subject / activity",
    ln_use_location: "Place of use",
    ln_note: "Notes",
    ln_take_home: "Take outside school (special request)",
    ln_take_home_warn: "This item normally stays on campus. Your supervisor must approve first, then the ICT Admin.",
    ln_override: "Rule exception (ICT Admin)",
    ln_override_hint: "Reason for skipping the notice / length rules",
    ln_terms: "I accept responsibility for this equipment and will return it on time and in the same condition.",
    ln_available: "Available for this time",
    ln_not_available: "Not available for this time",
    ln_pending_others: "other request(s) pending",
    ln_policy_max: "Max",
    ln_days: "day(s)",
    ln_policy_approval: "needs ICT approval",
    ln_policy_auto: "approved automatically",
    ln_policy_takehome_ok: "may leave campus",
    ln_policy_takehome_no: "stays on campus",
    ln_state_available: "Available",
    ln_state_on_loan: "On loan",
    ln_state_scheduled: "In use (scheduled)",
    qr_cart_used: "units in use by the schedule",
    ln_in_use_now: "Reserved or used by a schedule right now",
    ln_state_repair: "In repair",
    ln_state_lost: "Lost",
    ln_state_inactive: "Inactive",
    ln_with: "with",
    ln_until: "until",
    ln_number: "No.",
    ln_asset: "Asset",
    ln_requester: "Requester",
    ln_period: "Period",
    ln_status: "Status",
    ln_empty: "No loans to show.",
    ln_back: "Back to loans",
    ln_units: "Units",
    pool_card_title: "Borrow laptops or iPads (outside the fixed schedule)",
    pool_card_hint: "Ask for the number of laptops or iPads you need. You do not choose specific devices: the ICT Admin picks which ones to lend, based on what is still free.",
    pool_laptops: "Borrow laptops",
    pool_ipads: "Borrow iPads",
    pool_request_title: "Borrow",
    pool_hint: "You can borrow more than one device. After the ICT Admin approves, you collect the devices that were assigned to you at the ICT room.",
    pool_units: "Number of devices",
    pool_free_now: "free for this time",
    pool_campus: "Campus",
    pool_why_none: "No loanable device of this kind is registered at your campus.",
    pool_why_total: "Registered",
    pool_why_busy: "On loan/reserved",
    pool_why_cart: "Held by cart schedule",
    pool_max_per_request: "Max per request",
    pool_pick_units: "Choose the devices to lend",
    pool_pick_hint: "Only devices that are free for this time are listed. Pick exactly as many as you approve.",
    pool_none_free: "No device of this type is free for this time.",
    pool_autopick: "Pick automatically",
    pool_limit_title: "Laptop / iPad request limit",
    pool_limit_hint: "The most laptops or iPads one teacher request may ask for on this campus.",

    // BYOD
    nav_byod: "Student BYOD",
    byod_kicker: "Bring Your Own Device",
    byod_title: "Student BYOD approvals",
    byod_subtitle: "Students may bring their own laptop, iPad or tablet for a project during a period set by the supervising teacher. Approval runs: parent, then teacher, then ICT, before the device gets school WiFi.",
    byod_tab_mine: "My projects",
    byod_tab_manage: "ICT queue",
    byod_tab_all: "All",
    byod_new: "New BYOD project",
    byod_export: "Export active devices",
    byod_empty: "No BYOD requests yet.",
    byod_number: "No.",
    byod_student: "Student",
    byod_project: "Project",
    byod_period: "Period",
    byod_status: "Status",
    byod_teacher: "Supervising teacher",
    byod_st_waiting_parent: "Waiting for parent",
    byod_st_waiting_teacher: "Waiting for teacher",
    byod_st_waiting_ict: "Waiting for ICT",
    byod_st_approved: "Approved",
    byod_st_scheduled: "Approved (not started)",
    byod_st_active: "Active",
    byod_st_expired: "Expired",
    byod_st_rejected: "Rejected",
    byod_st_cancelled: "Cancelled",
    byod_st_revoked: "Access revoked",
    byod_new_title: "New BYOD project",
    byod_new_hint: "Fill in the project and its students. Each parent receives their own one-time link to review and sign. The period can be at most 3 months.",
    byod_project_name: "Project / exhibition name",
    byod_subject: "Subject",
    byod_location: "Place of use",
    byod_start: "Start date",
    byod_end: "End date",
    byod_hour_from: "Allowed from",
    byod_hour_to: "Allowed until",
    byod_students: "Students",
    byod_add_student: "Add student",
    byod_remove: "Remove",
    byod_student_name: "Student name",
    byod_student_class: "Class",
    byod_student_no: "Student no.",
    byod_parent_name: "Parent / guardian name",
    byod_parent_email: "Parent e-mail",
    byod_parent_phone: "Parent WhatsApp",
    byod_contact_hint: "Fill in at least an e-mail or a WhatsApp number for each parent.",
    byod_create: "Create and send links",
    byod_created_title: "Links created",
    byod_created_hint: "The links were sent by e-mail / WhatsApp where possible. If a message could not be sent, copy the link and send it yourself. Each link works once and expires in 7 days.",
    byod_copy: "Copy link",
    byod_copied: "Link copied.",
    byod_sent_email: "e-mail sent",
    byod_sent_wa: "WhatsApp sent",
    byod_sent_none: "not sent: copy the link",
    byod_back: "Back to BYOD",
    byod_flow: "Approval flow",
    byod_step_parent: "Parent",
    byod_step_teacher: "Teacher",
    byod_step_ict: "ICT",
    byod_signed_on: "Signed",
    byod_pending: "Pending",
    byod_by: "by",
    byod_info: "Request",
    byod_allowed_hours: "Allowed hours",
    byod_campus: "Campus",
    byod_parent: "Parent / guardian",
    byod_relation: "Relationship",
    byod_devices: "Devices",
    byod_kind_laptop: "Laptop",
    byod_kind_ipad: "iPad",
    byod_kind_tablet: "Tablet",
    byod_brand: "Brand",
    byod_model: "Model",
    byod_os: "Operating system",
    byod_os_version: "OS version",
    byod_mac: "WiFi MAC address",
    byod_serial: "Serial no. (optional)",
    byod_signatures: "Signatures",
    byod_history: "History",
    byod_resend: "Send link again",
    byod_resend_done: "A new link was created. The old one no longer works.",
    byod_cancel: "Cancel request",
    byod_revoke: "Revoke access",
    byod_extend: "Request extension",
    byod_teacher_sign: "Sign as teacher",
    byod_decide: "ICT decision",
    byod_approve: "Approve",
    byod_reject: "Reject",
    byod_note: "Note",
    byod_reason: "Reason",
    byod_reason_required: "A reason is required.",
    byod_new_end: "New end date",
    byod_ext_hint: "One extension of up to 92 days. ICT must approve it; no new parent signature is needed.",
    byod_ext_pending: "Extension requested until",
    byod_decide_hint: "Check the devices below. You may correct the MAC address before approving. After approval, add the MAC addresses to the school WiFi.",
    byod_teacher_sign_title: "Teacher declaration",
    byod_teacher_statement: "I supervise this project and allow this student to use the listed personal device(s) only for the project, within the period and hours above. I will report any misuse to ICT.",
    byod_sign_name: "Type your full name",
    byod_sign_name_hint: "Must match your account name:",
    byod_draw: "Draw your signature",
    byod_clear: "Clear",
    byod_print: "Print / save as PDF",
    byod_saved: "Saved.",
    byod_ict_note: "ICT note",
    byod_end_reason: "Reason",
    byod_terms_h: "Terms accepted by the parent",
    byod_pub_title: "Parent approval — Bring Your Own Device (BYOD)",
    byod_pub_intro: "Your child has been proposed to bring a personal laptop, iPad or tablet to school for the project below. Please read the terms, enter the device details and sign. Only laptops, iPads and tablets are allowed; mobile phones are not.",
    byod_pub_student: "Student",
    byod_pub_project: "Project",
    byod_pub_teacher: "Supervising teacher",
    byod_pub_terms_h: "Terms and conditions (please tick every statement)",
    byod_s_own_device: "The device belongs to our family and my child is responsible for it, with my support.",
    byod_s_liability: "The school is not responsible for loss, theft or damage of the device, its data or accessories.",
    byod_s_project_only: "The device is used only for the project above, within the stated dates and hours, and is brought with its own charger.",
    byod_s_rules: "My child will follow the school's Responsible Use Policy and will not access prohibited content or bypass the school network's controls.",
    byod_s_monitoring: "I understand that internet use through the school network is monitored and filtered.",
    byod_s_revoke: "ICT may revoke WiFi access, and the teacher may hold the device temporarily, if the rules are broken or the period ends.",
    byod_s_privacy: "I agree that the student's and device's details are processed by the school for this purpose and kept as a signed record.",
    byod_pub_devices_h: "Device details (maximum 2)",
    byod_pub_device: "Device",
    byod_pub_add_device: "Add another device",
    byod_mac_optional: "optional",
    byod_pub_mac_help: "If you cannot find it, leave it blank — the school ICT team will help fill it in. Find the WiFi MAC address: Windows — Settings › Network › Hardware properties › Physical address; macOS — System Settings › Network › Wi-Fi › Details › Hardware; iPad — Settings › General › About › Wi-Fi Address; Android tablet — Settings › About tablet › Status. On iPad/Android, turn OFF 'Private Wi-Fi address' for the school network, otherwise the device cannot connect.",
    byod_pub_parent_h: "Parent / guardian",
    byod_pub_signature: "Signature (draw with finger or mouse)",
    byod_pub_submit: "I agree and sign",
    byod_pub_done_title: "Thank you, your approval was recorded",
    byod_pub_done_body: "The supervising teacher and the school ICT will review the request. You do not need to do anything else. The link can no longer be used.",
    byod_pub_invalid: "This link is not valid, was already used, or has expired. Please ask the supervising teacher to send a new link.",
    byod_pub_fix: "Please complete all fields, tick every statement and sign.",
    ln_borrower: "Borrower",
    ln_decision: "Decision",
    ln_decision_note: "Note / reason",
    ln_decided_by: "Decided by",
    ln_late: "Last-minute request",
    ln_late_hint: "Submitted on the day itself; depends on availability.",
    ln_unit_records: "Hand-over records",
    ln_checkout: "Check-out",
    ln_checkin: "Check-in",
    ln_handed_by: "Handed over by",
    ln_received_by: "Received by",
    ln_fault_created: "A fault report was created in",
    ln_act_decide: "Confirm request",
    ln_act_supervisor: "Supervisor decision",
    ln_act_checkout: "Hand over (check-out)",
    ln_act_checkin: "Receive return (check-in)",
    ln_act_cancel: "Cancel request",
    ln_approve: "Approve",
    ln_reject: "Reject",
    ln_physical: "Physical condition",
    ln_function: "Function",
    ln_accessories: "Accessories",
    ln_present: "Present",
    ln_missing: "Missing",
    ln_result: "Return result",
    ln_result_fault_hint: "A fault report will be opened automatically.",
    ln_damage_note: "Damage / loss description",
    ln_photo_before: "Photo before",
    ln_photo_before_hint: "Optional: attach the asset's condition photo now; it is reused at hand-over (auto-shrunk to max 50 KB)",
    ln_photo_after: "Photo after",
    ln_photo_hint: "Tap to take or choose a photo (auto-shrunk to max 50 KB)",
    ln_phys_baik: "Good",
    ln_phys_lecet: "Scratched",
    ln_phys_retak: "Cracked",
    ln_phys_lainnya: "Other",
    ln_fn_normal: "Normal",
    ln_fn_masalah: "Has a problem",
    ln_res_ok: "OK, same condition",
    ln_res_changed: "Condition changed (still usable)",
    ln_res_damaged: "Damaged (send to repair)",
    ln_res_lost: "Lost",
    ln_st_submitted: "Submitted",
    ln_st_pending_supervisor: "Waiting for supervisor",
    ln_st_pending_ict: "Waiting for ICT",
    ln_st_approved: "Approved",
    ln_st_partially_approved: "Partly approved",
    ln_st_rejected: "Rejected",
    ln_st_in_use: "In use",
    ln_st_completed: "Completed",
    ln_st_cancelled: "Cancelled",
    ln_st_overdue: "Overdue",
    ln_st_problem: "Problem",
    ln_sup_pending: "Waiting for supervisor",
    ln_sup_approved: "Supervisor approved",
    ln_sup_rejected: "Supervisor rejected",
    ln_unit_reserved: "Reserved",
    ln_unit_out: "Out",
    ln_unit_returned: "Returned",
    ln_unit_not_returned: "Not returned",
    ln_unit_lost: "Lost",
    ln_unit_damaged: "Damaged",
    ln_settings: "Loan settings",
    ln_borrowable: "Can be borrowed",
    ln_borrowable_yes: "This asset can be borrowed.",
    ln_borrowable_no: "This asset is not open for loans.",
    ln_storage_slot: "Storage location / slot",
    ln_max_days: "Max loan (days)",
    ln_needs_approval: "Needs approval",
    ln_can_leave: "May leave campus",
    ln_use_category_rule: "Use category rule",
    ln_yes: "Yes",
    ln_no: "No",
    ln_accessories_standard: "Standard accessories (one per line)",
    ln_accessories_hint: "Charger\nBag\nLens",
    ln_history: "Loan history",
    ln_history_empty: "No loans recorded yet.",

    // Schedule module
    nav_schedule: "Schedule & labs",
    ln_cart_units_back: "Units returned",
    ln_cart_units_out: "Units handed over",
    ln_not_handed: "not handed over",
    ln_not_returned: "not returned",
    ln_photo_cart: "Photo of the whole cart / room",
    ln_photo_cart_hint: "All slots / seats must be visible",
    ln_problem_flag: "Report problem",
    ln_problem_remove: "Remove problem",
    ln_units_still_out: "unit(s) not returned yet",
    sc_kicker: "Availability",
    sc_title: "Schedule & labs",
    sc_subtitle: "Weekly calendar of laptop / iPad carts and computer labs. Green means units are free, red means fully used. Fixed class schedules are locked; pick a free slot to request extra use.",
    sc_setup: "Schedule setup",
    sc_no_resources: "No carts or labs are set up for your campus yet.",
    sc_no_periods: "The lesson periods of this campus have not been set up yet.",
    sc_this_week: "This week",
    sc_capacity: "Units available",
    sc_legend_free: "Free",
    sc_legend_used: "Fully used",
    sc_period: "Period",
    sc_free: "Free",
    sc_full: "Full",
    sc_holiday: "Holiday",
    sc_pending: "pending",
    sc_empty_slot: "Nothing scheduled in this slot.",
    sc_request_title: "Request outside the schedule",
    sc_until_period: "Until period",
    sc_mon: "Mon",
    sc_tue: "Tue",
    sc_wed: "Wed",
    sc_thu: "Thu",
    sc_fri: "Fri",
    sc_sat: "Sat",
    sc_sun: "Sun",
    sc_type_fixed: "Fixed schedule",
    sc_type_booking: "Request",
    sc_type_libur: "Session cancelled (holiday)",
    sc_open_session: "Hand over this session",
    sc_mark_libur: "Mark as holiday",
    sc_open_loan: "Open hand-over",
    su_tab_resources: "Carts & labs",
    su_tab_periods: "Lesson periods",
    su_tab_holidays: "School holidays",
    su_tab_schedules: "Fixed schedules",
    su_tab_pairings: "Unit & student pairs",
    su_add: "Add",
    su_name: "Name",
    su_kind: "Type",
    su_category: "Category",
    su_capacity: "Capacity",
    su_units: "Units",
    su_units_edit: "Units in it",
    su_selected: "selected",
    su_active: "Active",
    su_inactive: "inactive",
    su_kind_laptop_cart: "Laptop cart",
    su_kind_ipad_cart: "iPad cart",
    su_kind_computer_lab: "Computer lab",
    su_kind_room: "Room",
    su_add_resource: "Add cart / lab",
    su_resource_hint: "Capacity is used until units are registered; once units are added, only active units count.",
    su_no_units: "No units in this cart yet. Add them on the Carts & labs tab.",
    su_periods_hint: "The master list of lesson periods for each school unit (PAUD / SD / SMP) of this campus (e.g. period 1 = 07:30–08:10). Pick a unit and fill its own times; carts / labs use the list of their unit in the calendar and fixed schedules.",
    su_school_unit: "School unit",
    su_start_date: "Start date",
    su_end_date: "End date",
    su_holidays_hint: "Requests are blocked and fixed sessions do not run on these dates.",
    su_date: "Date",
    su_all_campuses: "All campuses",
    su_add_schedule: "Add fixed schedule",
    su_schedule_hint: "Entered once per semester by the ICT Admin. The slot is locked for other requests.",
    su_resource: "Cart / lab",
    su_year: "Academic year",
    su_semester: "Semester",
    su_teacher: "Teacher",
    su_weekday: "Day",
    su_period_from: "From period",
    su_period_to: "To period",
    su_valid_from: "Valid from",
    su_valid_to: "Valid until",
    su_valid: "Valid",
    su_restore: "restore",
    su_pairings_hint: "Pair every unit with a student for the semester (e.g. iPad 12 is always roll number 12), so the user of each unit is always known.",
    su_paste: "Paste a list",
    su_apply: "Apply",
    su_roll: "Roll no.",
    su_student: "Student",

    // Loans phase 3
    nav_scan: "Scan loans",
    nav_scan_asset: "Scan asset",
    qr_loan_title: "Scan for loans",
    qr_loan_subtitle: "Scan an asset label to see its status and go straight to the hand-over or return. During a class session, scanning a cart unit opens that session's hand-over.",
    qr_handover_session: "Hand over scheduled session",
    qr_session: "Schedule session",
    qr_asset_kicker: "ASSET CHECK",
    qr_asset_title: "Scan asset",
    qr_asset_subtitle: "Scan a label to open the asset, or register a new asset when its code is not in the system yet.",
    qr_asset_unknown: "This code is not registered yet.",
    qr_asset_register: "Register as new asset",
    ln_tab_dashboard: "Dashboard",
    qr_title: "Scan QR",
    qr_subtitle: "Scan an asset label to see its status and go straight to the hand-over or return.",
    qr_camera_error: "The camera is not available. Type the asset code instead.",
    qr_manual: "Or type the asset code, e.g. YPJ-KAM-005",
    qr_multi_toggle: "Lend several units at once (scan into a basket)",
    qr_multi_basket: "Basket",
    qr_multi_empty: "Scan each laptop / iPad label; every available unit is added here.",
    qr_multi_dup: "already in the basket",
    qr_multi_borrower: "Borrower",
    qr_multi_search: "Type a name or email…",
    qr_multi_no_user: "No matching user",
    qr_multi_until: "Return by",
    qr_multi_class: "Class (optional)",
    qr_multi_purpose: "Purpose",
    qr_multi_terms: "Creating the loan records the borrower's responsibility for these units. The hand-over (condition and photo) is completed on the next page.",
    qr_multi_create: "Create one loan for {n} units",
    qr_multi_created: "Loan created for {n} units — complete the hand-over",
    qr_multi_handed: "{n} units handed over",
    qr_multi_photo: "Group photo of all units (optional)",
    qr_multi_photo_ok: "photo added",
    qr_multi_photo_hint: "With a photo, all units are recorded as handed over in good condition in the same step. Without it, finish the hand-over on the loan page (per-unit condition and photo).",
    qr_multi_create_out: "Create loan and hand over {n} units",
    qr_scan_next: "Scan next",
    qr_reading: "Read",
    qr_searching: "Looking for a code… hold the camera 15–30 cm from the label",
    qr_find: "Find",
    qr_pickup: "To be picked up today",
    qr_no_action: "No loan to hand over or take back for this asset right now.",
    qr_open_asset: "Open asset",
    qr_borrow: "Borrow this asset",
    qr_not_borrowable: "This asset is not open for loans.",
    qr_print_labels: "Print barcode labels",
    qr_print_these: "Print barcodes",
    qr_print_one: "Print barcode",
    qr_picked_hint: "Showing the barcode stickers of {n} selected asset(s).",
    qr_picked_all: "Show all assets instead",
    qr_labels_hint: "Stick the barcode on the asset. Scan it in Scan loans / Scan asset with the camera or a USB barcode scanner.",
    qr_select_all: "Select all",
    qr_print: "Print",
    qr_scan_units: "Scan units",
    pick_selected: "selected",
    pick_hint: "Scan each device's QR or search it, so every device that is lent out is recorded.",
    pick_search: "Search device name / asset code",
    pick_full: "Already {n} devices selected (the approved amount). Untick one first.",
    pick_none: "No device matches.",
    qr_scanned: "scanned",
    qr_not_in_cart: "not in this cart",
    qr_done: "Done",
    db_pending: "Waiting for confirmation",
    db_out: "On loan",
    db_not_returned: "Not returned",
    db_broken: "Damaged / lost",
    db_today: "Today",
    db_none_late: "Nothing overdue.",
    db_last_user: "Last user",
    db_due: "Due",
    db_contact: "Contact",
    rp_loans_title: "Loan reports",
    rp_usage: "Monthly usage",
    rp_usage_desc: "Use per class, and requests outside the schedule (approved and rejected), to judge whether more units are needed.",
    rp_show: "Show",
    rp_by_class: "Usage per class",
    rp_fixed: "Fixed sessions",
    rp_extra: "Extra sessions",
    rp_hours: "Hours",
    rp_off_schedule: "Requests outside the schedule",
    rp_off_hint: "Many rejected requests or units requested above units approved suggest more units are needed.",
    rp_requests: "Requests",
    rp_approved: "Approved",
    rp_partial: "Partly",
    rp_rejected: "Rejected",
    rp_units_req: "Units asked",
    rp_units_ok: "Units given",
    rp_items: "Item loans",
    rp_loans: "Loans",
    rp_problems: "Problems",
    rp_incidents: "Damage & loss",
    rp_incidents_desc: "Asset code, chronology, last user, last photo and follow-up for every return with a change in condition.",
    rp_code: "Asset",
    rp_chronology: "Chronology",
    rp_follow_up: "Follow-up",
    us_phone: "WhatsApp number",
    us_phone_hint: "Used for loan notifications (start with 0 or 62).",
  },

  ID: {
    // Layout / nav
    nav_dashboard: "Dasbor",
    nav_assets: "Aset",
    nav_faults: "Kerusakan",
    nav_compliance: "Kepatuhan",
    nav_users: "Pengguna",
    nav_reports: "Laporan",
    nav_activity: "Log Aktivitas",
    nav_help: "Bantuan & Panduan",
    nav_policies: "Kebijakan & Prosedur",
    brand_subtitle: "Manajemen Aset Sekolah",
    nav_section: "Navigasi",
    lang_label: "Bahasa",
    backup: "Cadangkan",
    backing_up: "Mencadangkan…",
    signed_in_as: "Masuk sebagai",
    sign_out: "Keluar",
    backup_ok: "Cadangan diunduh",
    backup_err: "Cadangan belum tersedia",
    topbar_title: "Manajemen Aset Sekolah",

    // Login
    welcome_back: "Selamat datang kembali",
    login_tagline: "Kelola setiap aset, dari ruang kelas hingga kampus.",
    login_sub: "Kelola seluruh aset sekolah di semua kampus — pantau kepemilikan, pemeliharaan, dan kepatuhan dari satu tempat.",
    tab_signin: "Masuk",
    tab_register: "Buat akun",
    email: "Email",
    password: "Kata sandi",
    signing_in: "Sedang masuk…",
    demo_accounts: "Akun demo",
    full_name: "Nama lengkap",
    department: "Departemen",
    dept_placeholder: "mis. Departemen Sains",
    creating: "Membuat…",
    create_staff: "Buat akun staf",
    footer_copy: "Manajemen Aset Sekolah YPJ",
    login_hero_label: "Dibuat untuk sekolah",
    login_hero_quote: "Sekolah yang Inovatif dan Progresif dengan Empati, Integritas, dan Pikiran Terbuka",
    login_hero_attr: "YPJ School",

    // Assets list
    inventory: "Inventaris",
    assets: "Aset",
    add_asset: "Tambah aset",
    search_placeholder: "Cari berdasarkan nama, tag, atau nomor seri…",
    all_campuses: "Semua kampus",
    all_categories: "Semua kategori",
    all_statuses: "Semua status",
    col_tag: "Tag",
    col_asset: "Aset",
    col_category: "Kategori",
    asset_property_by: "Properti Aset Dari",
    col_asset_property_of: "Properti Aset Dari",
    asset_type_school: "Aset Sekolah",
    asset_type_company: "Aset Perusahaan",
    col_campus: "Kampus",
    col_supervisor: "Supervisor",
    supervisor_name: "Nama Supervisor",
    supervisor_email: "Email Supervisor",
    supervisor_placeholder: "cth. supervisor@fmi.com",
    col_employee_id: "ID Karyawan",
    col_room: "Ruangan",
    col_assigned: "Ditugaskan",
    col_status: "Status",
    col_book_value: "Nilai Buku",
    loading: "Memuat…",
    no_assets: "Tidak ada aset ditemukan",
    no_assets_sub: "Coba sesuaikan filter atau tambahkan aset pertama Anda.",
    last_refreshed: "Diperbarui",
    count_asset: "aset",
    count_assets: "aset",
    asset_categories: "kategori",
    expand_all: "Buka semua",
    collapse_all: "Tutup semua",

    // Status labels
    status_active: "Aktif",
    status_in_repair: "Dalam Perbaikan",
    status_retired: "Tidak Aktif",
    status_lost: "Hilang",

    // Categories
    cat_it: "Peralatan IT",
    cat_av: "Peralatan AV",
    cat_furniture: "Furnitur",
    cat_lab: "Peralatan Lab",
    cat_vehicles: "Kendaraan",
    cat_books: "Buku",
    cat_sports: "Olahraga",
    cat_music: "Peralatan Musik",
    cat_learning: "Alat Peraga Pembelajaran",
    cat_erg: "Peralatan ERG / Fire Drill",
    cat_housekeeping: "Peralatan Housekeeping",
    cat_firstaid: "Peralatan P3K / AED",
    cat_tools: "Peralatan Kerja / Tools",
    cat_other: "Lainnya",

    // Asset form
    back: "Kembali",
    edit_asset: "Edit aset",
    new_asset: "Aset baru",
    register_asset: "Daftarkan aset baru",
    section_basic: "01 — Identitas",
    asset_name: "Nama aset",
    asset_tag: "Tag aset / barcode",
    asset_tag_placeholder: "mis. FUR-DSK-0001",
    rn_button: "Pulihkan nama aset dari ekspor lama",
    rn_hint: "unggah ekspor aset yang lama (.xlsx); aset yang namanya tinggal angka dikembalikan ke nama lamanya.",
    rn_done: "{n} nama dipulihkan, {m} tidak ditemukan di file",
    bu_pick: "Tetapkan unit sekolah…",
    bu_apply: "Terapkan unit",
    bu_done: "{n} aset diperbarui",
    unit_skipped: "{n} dilewati",
    unit_auto: "Samakan unit dengan lab dan cart",
    assign_approval: "Assign wajib persetujuan atasan",
    assign_approval_yes: "Ya, CC admin dan leader (aset penting)",
    assign_approval_yes2: "Ya, CC admin saja (aset biasa)",
    assign_approval_hint: "Jika aktif: atasan guru penerima (kepala sekolah untuk SMP) menyetujui lebih dulu, baru guru mengonfirmasi. Admin resources dan admin kampus selalu di-CC; pilihan pertama juga meng-CC leader kampus, jadi pakai pilihan kedua untuk aset biasa seperti alat lab.",
    aa_on: "Persetujuan + CC leader",
    aa_status: "Persetujuan",
    bu_status: "Unit sekolah",
    bu_unset: "belum diisi",
    bl_status: "Peminjaman",
    bl_state_1: "bisa dipinjam",
    bl_state_0: "tidak untuk dipinjam",
    bl_state_none: "belum ditentukan",
    bl_badge_1: "Bisa dipinjam",
    bl_badge_0: "Tidak dipinjam",
    aa_state_0: "tanpa persetujuan",
    aa_state_1: "persetujuan, CC admin + leader",
    aa_state_2: "persetujuan, CC admin saja",
    aa_state_mixed: "campur (berbeda antar aset terpilih)",
    aa_badge_1: "Persetujuan · +leader",
    aa_badge_2: "Persetujuan · admin",
    aa_on2: "Persetujuan, CC admin saja",
    aa_off: "Tanpa persetujuan",
    aa_done_on: "{n} aset sekarang wajib persetujuan atasan saat di-assign",
    aa_done_off: "{n} aset tidak lagi wajib persetujuan saat di-assign",
    aa_waiting: "{n} menunggu persetujuan {name}",
    aa_cc_missing: "Orang berikut di daftar CC email belum terdaftar sebagai pengguna, jadi tidak mendapat salinan: {names}. Tambahkan di menu Users.",
    aa_unit_scope: "Sebagian aset dilewati: milik unit sekolah yang tidak Anda tangani.",
    aa_no_supervisor: "Sebagian aset dilewati: wajib persetujuan, tetapi guru penerima belum punya supervisor terdaftar. Isi supervisor di menu Users.",
    aa_title: "Serah terima menunggu persetujuan Anda",
    aa_hint: "Setujui agar guru dapat memeriksa dan menerima asetnya, atau tolak dengan alasan.",
    aa_to: "ke",
    aa_approve: "Setujui",
    aa_approved_toast: "Disetujui. Guru diminta untuk mengonfirmasi.",
    aa_rejected_toast: "Ditolak. Admin diberi tahu.",
    aa_status_waiting: "Menunggu persetujuan {name}",
    bl_on: "Jadikan dapat dipinjam",
    bl_off: "Bukan untuk dipinjam",
    bl_done_on: "{n} aset sekarang dapat dipinjam",
    bl_done_off: "{n} aset tidak lagi dapat dipinjam",
    qr_mode_loan: "Aset dipinjamkan (perangkat IT, Multimedia dan Tools)",
    qr_mode_fixed: "Aset ditugaskan (tidak dipinjamkan)",
    qr_fixed_hint: "Stiker untuk aset yang tetap di tempatnya, seperti furnitur dan jam dinding. Hasil scan membuka halaman aset, bukan peminjaman. Keterangan diakhiri nama ruangan.",
    qr_all_categories: "Semua kategori",
    qr_select_none: "Hapus pilihan",
    sp_button: "Pakai foto ini untuk semua nomor",
    sp_confirm: "Pakai foto ini untuk {n} aset lain dengan nama yang sama (#1, #2, …)? Foto mereka yang sekarang diganti.",
    sp_none: "Tidak ada aset bernomor lain dengan nama ini.",
    sp_done: "Foto dipakai untuk {n} aset",
    bu_auto_hint: "Unit di dalam cart atau lab mengikuti unit sekolah cart / lab itu (sesuai jadwal). Sisanya yang belum punya unit: Student's Desktop → SMP, Student's Laptop → SD, iPad bernama PAUD atau SD.",
    asset_tag_auto: "Dibuat otomatis",
    asset_tag_auto_hint: "Nomor barcode angka yang unik dibuat saat aset disimpan dan tidak bisa diubah.",
    campus: "Kampus",
    select_campus: "Pilih kampus…",
    room_location: "Ruangan / Lokasi",
    room_placeholder: "mis. Lab Komputer A",
    status: "Status",
    description: "Deskripsi",
    serial_number: "Nomor seri",
    initial_owner: "Penanggung jawab / PIC (pemilik awal)",
    initial_owner_placeholder: "mis. Maria Hernandez",
    section_financials: "07 — Keuangan & Penyusutan",
    purchase_price: "Harga beli (Rp)",
    purchase_date: "Tanggal pembelian",
    useful_life: "Umur manfaat (tahun)",
    warranty_end: "Tanggal akhir garansi",
    supplier: "Pemasok / vendor",
    section_media: "08 — Foto & Dokumen",
    section_location: "02 — Lokasi & Penanggung Jawab",
    section_acquisition: "03 — Perolehan",
    section_condition: "04 — Kondisi & Inspeksi",
    section_maintenance: "05 — Pemeliharaan",
    section_warranty: "06 — Garansi",
    asset_code: "ID aset",
    asset_code_placeholder: "Dibuat otomatis saat disimpan",
    asset_code_hint: "Terkunci: ID dibuat otomatis (kampus-kategori-nomor).",
    asset_code_hint_super: "Hanya super admin yang bisa mengubahnya. Kosongkan pada aset baru agar dibuat otomatis.",
    item_type: "Jenis aset",
    item_type_placeholder: "mis. Meja siswa",
    brand: "Merek",
    brand_placeholder: "mis. IKEA",
    model: "Model",
    model_placeholder: "mis. Meja single 60x40",
    unit: "Unit",
    select_generic: "Pilih…",
    building: "Gedung",
    building_placeholder: "mis. Gedung SMP",
    asset_department: "Departemen / fungsi",
    asset_department_placeholder: "mis. Akademik",
    user_type: "Tipe pengguna",
    acquisition_type: "Jenis perolehan",
    po_number: "No. PO / kontrak",
    po_placeholder: "mis. PO-2026-00125",
    funding_source: "Sumber dana",
    funding_placeholder: "mis. Anggaran sekolah",
    asset_condition: "Kondisi",
    condition_notes: "Catatan kondisi",
    last_inspection: "Tanggal inspeksi terakhir",
    next_inspection: "Tanggal inspeksi berikutnya",
    maintenance_required: "Perlu pemeliharaan",
    last_maintenance: "Tanggal pemeliharaan terakhir",
    next_maintenance: "Tanggal pemeliharaan berikutnya",
    maintenance_provider: "Penyedia pemeliharaan",
    maintenance_provider_placeholder: "Vendor atau internal",
    maintenance_cost: "Biaya pemeliharaan (Rp)",
    warranty_start: "Tanggal mulai garansi",
    warranty_provider: "Penyedia garansi",
    residual_value: "Nilai sisa (Rp)",
    updated_label: "Terakhir diperbarui",
    opt_yes: "Ya",
    opt_no: "Tidak",
    unit_paud: "PAUD",
    unit_sd: "SD",
    unit_smp: "SMP",
    unit_admin: "Administrasi",
    unit_shared: "Bersama / lainnya",
    cond_good: "Baik",
    cond_fair: "Cukup",
    cond_poor: "Kurang",
    cond_damaged: "Rusak",
    acq_purchase: "Pembelian",
    acq_donation: "Hibah / donasi",
    acq_transfer: "Mutasi / transfer",
    ut_employee: "Karyawan",
    ut_shared: "Bersama",
    ut_classroom: "Kelas",
    doc_invoice: "Faktur / kuitansi",
    doc_warranty: "Dokumen garansi",
    doc_supporting: "Dokumen pendukung",
    due_title: "Inspeksi & pemeliharaan jatuh tempo",
    due_none: "Tidak ada yang jatuh tempo dalam 60 hari ke depan.",
    fx_note: "Nilai disimpan dalam Rupiah.",
    fx_note_fallback: "Nilai disimpan dalam Rupiah.",
    due_send_now: "Kirim pengingat sekarang",
    due_sending: "Mengirim…",
    due_send_confirm: "Kirim email pengingat sekarang ke kepala kampus dan inbox umum untuk semua yang jatuh tempo dalam 30 hari atau sudah terlambat?",
    due_send_none: "Tidak ada yang jatuh tempo dalam 30 hari atau terlambat — tidak ada email dikirim.",
    due_send_no_email: "Email belum dikonfigurasi di server — tidak ada yang terkirim.",
    due_send_no_recipients: "Penerima pengingat belum dikonfigurasi — tidak ada yang terkirim.",
    due_sent: "Pengingat terkirim: {items} item dalam {emails} email.",
    due_inspection: "Inspeksi",
    due_maintenance: "Pemeliharaan",
    due_days_overdue: "hari terlambat",
    due_today: "jatuh tempo hari ini",
    due_in: "dalam",
    due_days: "hari",
    asset_photo: "Foto aset",
    click_upload_photo: "Klik untuk unggah foto",
    uploading: "Mengunggah…",
    documents_label: "Dokumen (PDF, dll.)",
    attach_doc: "Lampirkan dokumen",
    upload_size_limit: "Ukuran bebas: foto otomatis dikecilkan menjadi maks. 100 KB saat disimpan",
    upload_doc_size_limit: "Ukuran file maks: 1 MB",
    photo_uploaded: "Foto diunggah",
    doc_attached: "Dokumen dilampirkan",
    photo_too_large: "Foto tidak bisa dikecilkan hingga 100 KB. Coba gambar lain.",
    doc_too_large: "Dokumen tidak boleh lebih dari 1 MB.",
    compliance_created: "Item kepatuhan dibuat",
    delete_compliance_confirm: "Hapus item kepatuhan ini?",
    fault_updated: "Kerusakan diperbarui",
    user_created_ok: "Pengguna dibuat",
    user_updated_ok: "Pengguna diperbarui",
    edit_user: "Edit pengguna",
    new_password_optional: "Password baru (opsional)",
    leave_blank_unchanged: "Kosongkan untuk tidak mengubah",
    delete_user_confirm: "Hapus {{name}}?",
    asset_transferred: "Aset dialihkan",
    transfer_request_submitted: "Permintaan alih telah dikirim untuk disetujui.",
    transfer_owner_required: "Pilih atau masukkan pemilik baru.",
    nav_my_assets: "Aset Saya",
    nav_user_assets: "Aset per Pengguna",
    ma_eyebrow: "Penguasaan aset",
    ma_title: "Aset saya",
    ma_subtitle: "Barang yang diserahkan kepada Anda. Barang baru tercatat atas nama Anda setelah Anda mengonfirmasi penerimaannya.",
    ma_kpi_personal: "Aset pribadi",
    ma_kpi_class: "Aset kelas",
    ma_kpi_pending: "Menunggu konfirmasi",
    ma_kpi_value: "Nilai buku",
    ma_pending_title: "Mohon konfirmasi penerimaan",
    ma_pending_hint: "Periksa fisik barangnya, lalu tekan Terima. Tolak dengan alasan jika ada yang tidak sesuai.",
    ma_accept: "Terima",
    ma_accept_selected: "Terima terpilih ({n})",
    ma_accept_all: "Terima semua",
    ma_reject: "Tolak",
    ma_reject_selected: "Tolak terpilih ({n})",
    ma_reject_title: "Tolak serah terima",
    ma_reject_reason: "Alasan (wajib)",
    ma_reject_placeholder: "mis. Barang tidak ada di ruangan / rusak",
    ma_accepted_toast: "{n} aset diterima",
    ma_rejected_toast: "{n} aset ditolak",
    ma_from: "Dari",
    ma_by: "Diserahkan oleh",
    ma_new_asset: "Aset baru",
    ma_kind_personal: "Pribadi",
    assign_kind: "Dipegang sebagai",
    asset_quantity: "Jumlah",
    asset_quantity_hint: "1 = satu aset. Untuk barang identik (10 bel kuis) isi jumlahnya: dibuat satu aset per barang.",
    asset_quantity_many: "Membuat {n} aset bernama \"{name} #1…\", masing-masing dengan barcode sendiri serta foto, ruang, dan pemilik yang sama.",
    asset_created_many: "{n} aset dibuat: {first} … {last}",
    assign_kind_hint: "Pribadi: dipegang orangnya (laptop, tablet). Kelas: tetap di ruangan dan guru bertanggung jawab (alat musik, alat peraga).",
    ma_kind_class: "Kelas",
    ma_tab_all: "Semua",
    ma_empty: "Belum ada aset yang diserahkan kepada Anda.",
    ma_waiting_days: "menunggu {n} hari",
    ma_col_asset: "Aset",
    ma_col_location: "Lokasi",
    ma_col_category: "Kategori",
    ma_col_type: "Jenis",
    ma_col_value: "Nilai buku",
    ma_col_status: "Status",
    ua_title: "Aset per pengguna",
    ua_subtitle: "Siapa memegang apa. Serah terima yang belum dikonfirmasi belum dihitung.",
    ua_kpi_users: "Pengguna",
    ua_kpi_with_users: "Aset dipegang pengguna",
    ua_kpi_unassigned: "Tanpa pemegang",
    ua_kpi_pending: "Menunggu konfirmasi",
    ua_search: "Cari pengguna…",
    ua_col_user: "Pengguna",
    ua_col_personal: "Pribadi",
    ua_col_class: "Kelas",
    ua_col_pending: "Menunggu",
    ua_col_value: "Nilai buku",
    ua_detail_title: "Aset yang dipegang {name}",
    ua_detail_hint: "Pilih pengguna pada tabel untuk melihat asetnya.",
    ua_pending_list: "Serah terima menunggu konfirmasi",
    ua_cancel: "Batalkan",
    ua_cancelled_toast: "Serah terima dibatalkan",
    ua_handover_btn: "Serah terima aset kelas",
    ua_none: "Pengguna tidak ditemukan.",
    ho_title: "Ganti guru penanggung jawab",
    ho_hint: "Guru baru menerima email (supervisor di-CC) dan memeriksa setiap aset: terima, atau laporkan tidak ada/rusak. Perubahan berlaku setelah semuanya diperiksa.",
    ho_recipient: "Penerima",
    ho_recipient_ph: "Pilih pengguna…",
    ho_room: "Ruang / lokasi",
    ho_room_ph: "Pilih ruang…",
    ho_select_all: "Pilih semua",
    ho_note: "Catatan (opsional)",
    ho_kind: "Jenis",
    ho_none: "Tidak ada aset aktif di ruang ini.",
    ho_current: "saat ini: {name}",
    ho_waiting: "menunggu konfirmasi",
    ho_submit: "Kirim untuk konfirmasi",
    ho_result: "{n} aset dikirim untuk konfirmasi",
    ho_skipped: "{n} dilewati",
    awaiting_confirmation: "Menunggu konfirmasi",
    awaiting_approval: "Menunggu persetujuan",
    pending_banner_approval: "Menunggu persetujuan {approver}, lalu {name} mengonfirmasi penerimaan",
    nav_classrooms: "Kelas & ruang",
    cr_eyebrow: "Aset kelas",
    cr_title: "Kelas & ruangan",
    cr_subtitle: "Aset kelas milik ruangan, bukan milik guru. Saat guru berganti, lakukan serah terima: guru baru memeriksa setiap aset.",
    cr_add: "Tambah ruang",
    cr_create_title: "Tambah kelas / ruang",
    cr_save: "Simpan",
    cr_created: "Ruang ditambahkan",
    cr_search: "Cari ruang atau guru…",
    cr_empty: "Tidak ada ruang.",
    cr_name: "Ruang",
    cr_campus: "Kampus",
    cr_type: "Jenis",
    cr_type_kelas: "Kelas",
    cr_type_lab: "Laboratorium",
    cr_type_kantor: "Kantor",
    cr_type_lainnya: "Lainnya",
    cr_responsible: "Guru penanggung jawab",
    cr_none_resp: "— Belum ditetapkan —",
    cr_class_assets: "Aset kelas",
    cr_personal_assets: "Aset personal",
    cr_value: "Nilai perolehan",
    cr_status: "Status",
    cr_handover_short: "Serah terima {n}/{t} diperiksa",
    cr_discrepancy: "Selisih serah terima",
    cr_discrepancy_hint: "Ditandai tidak ada/rusak oleh guru baru. Aset ini tetap pada pemegang sebelumnya sampai Anda menindaklanjuti.",
    cr_still_with: "masih pada",
    cr_resolve: "Tandai selesai",
    cr_resolve_all: "Selesaikan semua",
    cr_resolved: "Selisih diselesaikan",
    cr_back: "Semua ruang",
    cr_handover_btn: "Ganti guru penanggung jawab",
    cr_handover_title: "Serah terima sedang berjalan",
    cr_handover_progress: "{c} dari {t} aset diperiksa",
    cr_handover_note: "Perubahan berlaku setelah semua aset diperiksa. Sebelum itu guru sebelumnya tetap bertanggung jawab.",
    cr_cancel_handover: "Batalkan serah terima",
    cr_cancel_confirm: "Batalkan serah terima ini? Item yang sudah diperiksa akan dibuang.",
    cr_cancelled: "Serah terima dibatalkan",
    cr_holding: "Dipegang",
    cr_held_class: "Aset kelas",
    cr_held_personal: "Personal (tetap pada guru)",
    cr_personal_stays: "personal — tetap pada guru",
    cr_no_assets: "Belum ada aset di ruang ini.",
    cr_edit: "Ubah ruang",
    cr_edit_title: "Ubah ruang",
    cr_edit_hint: "Mengganti nama juga memperbarui lokasi semua aset di ruang ini.",
    cr_master_hint: "Ini daftar induk ruangan. Form aset dan transfer memilih nama ruang dari sini, jadi satu ruang hanya dinamai sekali. Ganti nama, gabungkan duplikat, atau hapus ruang kosong lewat ikon di baris.",
    cr_delete: "Hapus ruang",
    cr_delete_confirm: "Hapus ruang \"{name}\"? Hanya bisa kalau tidak ada aset di dalamnya.",
    cr_deleted: "Ruang dihapus",
    cr_merge_title: "Gabungkan ke ruang lain",
    cr_merge_hint: "Pakai untuk duplikat bernama mirip: asetnya pindah ke ruang yang Anda pilih, lalu ruang ini dihapus.",
    cr_merge_pick: "Pilih ruang yang dipertahankan…",
    cr_merge_btn: "Gabungkan",
    cr_name_taken: "Ruang bernama \"{name}\" sudah terdaftar. Pakai Gabungkan di bawah untuk menyatukannya.",
    cr_registered_like: "Ruang terdaftar yang cocok:",
    cr_merge_into_this: "gabungkan ke sini",
    cr_merge_confirm: "Pindahkan semua dari \"{from}\" ke \"{to}\" lalu hapus \"{from}\"?",
    cr_merged: "{n} aset dipindah ke {to}",
    room_pick: "Cari dan pilih ruang…",
    room_search: "Cari ruang…",
    room_none: "Tidak ada ruang terdaftar yang cocok.",
    room_register: "+ Daftarkan \"{name}\" sebagai ruang baru",
    room_ask_admin: "Tidak ada di daftar? Minta admin mendaftarkannya di Kelas & ruangan.",
    room_unregistered: "Ruang ini belum ada di daftar induk. Pilih ruang yang terdaftar.",
    room_registered: "Ruang terdaftar",
    room_new: "Nama ruang baru (belum ada di daftar induk).",
    room_similar: "Maksud Anda:",
    room_manage: "Nama ruang dikelola di",
    room_confirm_use: "Ruang \"{name}\" mirip dengan ruang yang sudah ada: {list}.\n\nOK = pakai \"{first}\"\nBatal = putuskan berikutnya",
    room_confirm_new: "Buat \"{name}\" sebagai ruang baru yang terpisah?",
    cr_saved: "Ruang diperbarui",
    cr_make_class: "Jadikan aset kelas",
    cr_make_personal: "Jadikan personal",
    cr_kind_changed: "{n} aset diperbarui",
    cr_history: "Riwayat serah terima",
    cr_hist_done: "{a} diterima · {d} selisih",
    cr_hist_cancelled: "dibatalkan",
    cr_hist_pending: "berjalan",
    bt_title: "Transfer {n} aset terpilih",
    bt_hint: "Semua aset terpilih dikirim ke satu pengguna terdaftar yang akan mengonfirmasi penerimaan (supervisor di-CC).",
    bt_selected: "{n} dipilih",
    bt_transfer: "Assign / transfer terpilih",
    bt_room_hint: "Opsional. Semua aset terpilih ditempatkan di ruang terdaftar ini. Kosongkan agar ruang saat ini tidak berubah.",
    bt_clear: "Hapus pilihan",
    pending_banner: "Menunggu {name} mengonfirmasi penerimaan",
    owner_confirm_hint: "Hanya pengguna terdaftar. Mereka dikirimi email (CC ke atasan) dan harus mengonfirmasi sebelum tercatat atas namanya.",
    owner_none: "— Belum ada pemilik —",
    owner_edit_hint: "Untuk mengganti pemegang gunakan Transfer di halaman aset.",
    transfer_pending_toast: "Serah terima dikirim. {name} harus mengonfirmasi penerimaan.",
    asset_created_pending: "Aset disimpan. {name} dikirimi email untuk konfirmasi penerimaan.",
    transfer_approved: "Alih kepemilikan disetujui dan diterapkan.",
    transfer_rejected: "Permintaan alih kepemilikan ditolak.",
    request_transfer: "Minta alih kepemilikan",
    transfer_request_hint: "Permintaan Anda akan dikirim ke admin untuk disetujui sebelum alih kepemilikan berlaku.",
    submit_request: "Kirim permintaan",
    nav_transfer_requests: "Permintaan alih",
    tr_filter_pending: "Menunggu",
    tr_filter_approved: "Disetujui",
    tr_filter_rejected: "Ditolak",
    tr_filter_all: "Semua permintaan",
    tr_empty: "Tidak ada permintaan alih",
    tr_empty_sub: "Permintaan yang dikirim staf akan muncul di sini untuk ditinjau.",
    tr_my_empty: "Anda belum mengajukan permintaan alih kepemilikan.",
    tr_my_empty_sub: "Buka aset dan klik Alihkan untuk mengajukan permintaan.",
    tr_my_requests: "Permintaan Alih Saya",
    tr_my_subtitle: "Lacak status permintaan alih yang telah Anda kirim.",
    tr_requested_by: "Diminta oleh",
    tr_approved_by: "Disetujui oleh",
    tr_rejected_by: "Ditolak oleh",
    tr_reason: "Alasan",
    tr_unassigned: "Tidak ditugaskan",
    tr_approve: "Setujui",
    tr_reject: "Tolak",
    tr_reject_title: "Tolak permintaan alih",
    tr_reject_desc: "Berikan alasan opsional yang akan ditampilkan kepada pemohon.",
    tr_reject_reason_placeholder: "Alasan penolakan (opsional)",
    tr_confirm_reject: "Konfirmasi penolakan",

    // Loan requests
    nav_loan_requests: "Permintaan peminjaman",
    loan_request: "Minta peminjaman",
    loan_request_title: "Permintaan peminjaman aset",
    loan_request_hint: "Permintaan Anda akan dikirim ke admin untuk disetujui.",
    loan_purpose: "Tujuan",
    loan_purpose_placeholder: "cth. Penggunaan di kelas untuk proyek sains",
    loan_from: "Dari",
    loan_until: "Hingga",
    loan_from_label: "Tanggal mulai (opsional)",
    loan_until_label: "Tanggal selesai (opsional)",
    loan_request_submitted: "Permintaan peminjaman telah dikirim untuk disetujui.",
    loan_approved: "Permintaan peminjaman disetujui.",
    loan_rejected: "Permintaan peminjaman ditolak.",
    loan_empty: "Tidak ada permintaan peminjaman",
    loan_empty_sub: "Permintaan yang dikirim staf akan muncul di sini untuk ditinjau.",
    loan_my_empty: "Anda belum mengajukan permintaan peminjaman.",
    loan_my_empty_sub: "Buka aset dan klik Minta peminjaman untuk mengajukan permintaan.",
    loan_my_requests: "Permintaan Peminjaman Saya",
    loan_my_subtitle: "Lacak status permintaan peminjaman yang telah Anda kirim.",
    loan_reject_title: "Tolak permintaan peminjaman",
    loan_filter_active: "Aktif (dipinjam)",
    loan_filter_returned: "Dikembalikan",
    loan_deliver: "Serahkan aset",
    loan_deliver_title: "Catat pemeriksaan sebelum serah terima",
    loan_deliver_hint: "Dokumentasikan kondisi aset sebelum diserahkan ke peminjam.",
    loan_return: "Catat pengembalian",
    loan_return_title: "Catat pengembalian aset",
    loan_return_hint: "Dokumentasikan kondisi aset setelah dikembalikan.",
    loan_condition: "Kondisi",
    loan_condition_note: "Catatan kondisi (opsional)",
    loan_condition_note_placeholder: "Kerusakan yang terlihat, catatan, atau observasi…",
    loan_condition_photo: "Foto kondisi (opsional)",
    loan_condition_photo_hint: "Klik untuk mengunggah foto",
    loan_cond_good: "Baik",
    loan_cond_trouble: "Ada masalah",
    loan_cond_broken: "Rusak",
    loan_cond_missing: "Hilang",
    loan_confirm_deliver: "Konfirmasi serah terima",
    loan_confirm_return: "Konfirmasi pengembalian",
    loan_delivered_ok: "Aset diserahkan — peminjaman kini aktif.",
    loan_returned_ok: "Pengembalian dicatat.",
    loan_pre_check: "Pemeriksaan sebelum serah terima",
    loan_post_check: "Pemeriksaan pengembalian",
    loan_delivered_at: "Diserahkan",
    loan_returned_at: "Dikembalikan",

    export_excel: "Ekspor ke Excel",
    exporting: "Mengekspor…",

    // Bulk import
    import_assets: "Impor aset",
    import_modal_title: "Impor aset massal",
    import_step_upload: "Unggah file",
    import_step_preview: "Pratinjau",
    import_step_done: "Selesai",
    import_download_template: "Unduh template CSV",
    import_download_template_xlsx: "Unduh template Excel",
    import_drop_hint: "Seret file CSV atau Excel (.xlsx) ke sini, atau klik untuk memilih",
    import_file_selected: "File dipilih",
    import_preview_btn: "Pratinjau impor",
    import_rows_found: "baris ditemukan",
    import_valid: "valid",
    import_invalid: "bermasalah",
    import_confirm_btn: "Impor baris yang valid",
    import_importing: "Mengimpor…",
    import_done_title: "Impor selesai",
    import_done_msg: "{{imported}} aset diimpor, {{skipped}} dilewati.",
    import_pending_note: "{n} aset dikirim ke pemiliknya untuk dikonfirmasi lewat email.",
    import_owner_ignored: "{n} nama pemilik bukan pengguna terdaftar sehingga dibiarkan \"Belum ada pemilik\". Tambahkan di menu Pengguna, lalu assign.",
    import_done_close: "Tutup",
    import_col_row: "Baris",
    import_col_name: "Nama",
    import_col_tag: "Tag",
    import_col_category: "Kategori",
    import_col_campus: "Kampus",
    import_col_status: "Status",
    import_col_errors: "Kesalahan",
    import_no_valid: "Tidak ada baris valid untuk diimpor.",
    import_file_required: "Silakan pilih file terlebih dahulu.",

    fault_reported_ok: "Kerusakan dilaporkan",
    asset_load_error: "Gagal memuat aset",
    saving: "Menyimpan…",
    save_changes: "Simpan perubahan",
    create_asset: "Buat aset",
    cancel: "Batal",

    // Asset detail
    back_to_assets: "Kembali ke aset",
    quick_facts: "Informasi singkat",
    assigned_to: "Ditugaskan ke",
    purchased: "Dibeli",
    warranty_until: "Garansi hingga",
    depreciation: "Penyusutan",
    annual_dep: "Penyusutan tahunan",
    accumulated: "Terakumulasi",
    current_book_value: "Nilai buku saat ini",
    report_fault: "Laporkan kerusakan",
    report_a_fault: "Laporkan kerusakan",
    severity: "Tingkat keparahan",
    sev_low: "Rendah",
    sev_medium: "Sedang",
    sev_high: "Tinggi",
    submit: "Kirim",
    transfer: "Alihkan",
    transfer_ownership: "Alih kepemilikan",
    new_owner_label: "Pemilik baru / lokasi",
    send_invitation: "Kirim undangan",
    reset_password: "Reset kata sandi",
    invite_confirm: "Kirim email undangan ke {name} ({email}) berisi tautan untuk membuat kata sandi sendiri? Kata sandi lama tidak berlaku lagi sampai mereka membuatnya.",
    reset_confirm: "Kirim tautan reset kata sandi ke {name} ({email})? Kata sandi lama tetap berlaku sampai pengguna membuat yang baru.",
    invite_sent: "Undangan terkirim ke {email}",
    reset_sent: "Tautan reset terkirim ke {email}",
    link_send_failed: "Email gagal terkirim.",
    link_no_email: "Email belum dikonfigurasi.",
    link_copied: "Tautan sudah disalin; bagikan ke pengguna secara manual.",
    sp_title_invite: "Buat kata sandi Anda",
    sp_title_reset: "Atur kata sandi baru",
    sp_new: "Kata sandi baru",
    sp_confirm: "Ulangi kata sandi",
    sp_save: "Simpan kata sandi",
    sp_too_short: "Kata sandi minimal 6 karakter.",
    sp_mismatch: "Kata sandi tidak sama.",
    sp_invalid_title: "Tautan tidak valid",
    sp_invalid_sub: "Tautan ini sudah kedaluwarsa atau sudah dipakai. Minta tautan baru.",
    sp_request_new: "Minta tautan baru",
    sp_done_title: "Kata sandi tersimpan",
    sp_done_sub: "Anda sekarang bisa masuk dengan kata sandi baru. Mengalihkan…",
    fp_link: "Lupa kata sandi?",
    fp_title: "Lupa kata sandi?",
    fp_sub: "Masukkan email akun Anda, kami kirim tautan untuk membuat kata sandi baru.",
    fp_sent: "Jika email tersebut terdaftar, tautan reset sedang dikirim. Periksa kotak masuk (dan spam).",
    fp_send: "Kirim tautan reset",
    fp_back: "Kembali ke halaman masuk",
    close: "Tutup",
    bulk_add_users: "Tambah massal",
    us_search: "Cari nama, email, ID karyawan, departemen…",
    us_no_match: "Tidak ada pengguna yang cocok.",
    bu_title: "Tambah pengguna secara massal",
    bu_hint: "Unggah file CSV atau Excel dengan satu pengguna per baris (kolom: name, email, role, department, campus, supervisor_name, supervisor, employee_id, password). Hanya name dan email yang wajib. Kosongkan password agar dibuat otomatis.",
    bu_invite: "Kirim email berisi data login (email + kata sandi sementara) ke setiap pengguna baru",
    bu_skip_note: "Baris yang bermasalah dilewati; hanya baris valid yang dibuat.",
    bu_import_btn: "Buat {n} pengguna",
    bu_created: "pengguna dibuat",
    bu_skipped: "dilewati",
    bu_invited: "{n} email undangan terkirim",
    bu_no_email: "Email belum dikonfigurasi, sehingga undangan tidak terkirim.",
    bu_pw_warning: "Kata sandi hanya ditampilkan sekarang. Unduh atau bagikan sebelum menutup; pengguna sebaiknya menggantinya setelah login pertama.",
    bu_auto: "otomatis",
    bu_download: "Unduh daftar login (CSV)",
    new_owner_placeholder: "Cari pengguna terdaftar…",
    transfer_user_required: "Pilih pengguna terdaftar dari daftar. Jika belum ada, tambahkan dulu di menu Pengguna.",
    note: "Catatan",
    confirm_transfer: "Konfirmasi alih",
    edit: "Edit",
    tab_overview: "Ikhtisar",
    tab_ownership: "Kepemilikan",
    tab_faults: "Kerusakan",
    tab_documents: "Dokumen",
    cat_label: "Kategori",
    created_label: "Dibuat",
    no_ownership: "Tidak ada catatan kepemilikan.",
    transferred_to: "Dialihkan ke",
    no_faults: "Tidak ada laporan kerusakan.",
    no_documents: "Tidak ada dokumen terlampir.",
    asset_not_found: "Aset tidak ditemukan.",
    delete_asset_confirm: "Hapus aset ini? Tindakan ini tidak dapat dibatalkan.",
    asset_deleted: "Aset dihapus",

    // Dashboard
    overview: "Ikhtisar",
    asset_dashboard: "Dasbor Aset",
    total_assets: "Total aset",
    categories: "kategori",
    acc_depreciation: "Akumulasi penyusutan",
    straight_line: "Metode garis lurus",
    open_faults: "Kerusakan terbuka",
    compliance_overdue: "kepatuhan terlambat",
    forecast: "Prakiraan",
    book_value_6yr: "Nilai buku, 6 tahun ke depan",
    action_required: "Tindakan diperlukan",
    warranty_alerts: "Peringatan garansi",
    all_warranties_ok: "Semua garansi dalam kondisi baik.",
    expired: "Kedaluwarsa",
    expires: "Berlaku hingga",
    recent: "Terkini",
    fault_reports: "Laporan kerusakan",
    view_all: "Lihat semua →",
    no_faults_reported: "Tidak ada kerusakan dilaporkan.",
    by_category: "Berdasarkan kategori",
    due_30: "Jatuh tempo 30 hari",
    of_purchased: "Dari",
    purchased_label: "yang dibeli",

    // Faults
    maintenance: "Pemeliharaan",
    all_faults: "Semua kerusakan",
    filter_open: "Terbuka",
    filter_in_progress: "Sedang dikerjakan",
    filter_resolved: "Terselesaikan",
    no_fault_reports: "Tidak ada laporan kerusakan",
    faults_sub: "Laporan akan muncul di sini saat staf mengajukannya.",
    reported_by: "Dilaporkan oleh",
    sev_label: "Keparahan",
    mark_in_progress: "Tandai sedang dikerjakan",
    resolve: "Selesaikan",
    resolve_fault: "Selesaikan kerusakan",
    resolution_note: "Catatan penyelesaian (opsional)…",
    mark_resolved: "Tandai terselesaikan",

    // Compliance
    regulatory: "Regulasi",
    compliance_checks: "Pemeriksaan kepatuhan",
    add_check: "Tambah pemeriksaan",
    new_check: "Pemeriksaan kepatuhan baru",
    title_label: "Judul",
    cat_safety: "Keselamatan",
    cat_inspection: "Inspeksi",
    cat_certification: "Sertifikasi",
    cat_audit: "Audit",
    frequency: "Frekuensi",
    freq_once: "Sekali",
    freq_monthly: "Bulanan",
    freq_quarterly: "Triwulanan",
    freq_annual: "Tahunan",
    due_date: "Tanggal jatuh tempo",
    create: "Buat",
    no_checks: "Belum ada pemeriksaan kepatuhan",
    pending: "Menunggu",
    completed: "Selesai",
    mark_complete: "Tandai selesai",
    overdue: "Terlambat",

    // Users
    access_control: "Kontrol akses",
    team_users: "Tim & pengguna",
    add_user: "Tambah pengguna",
    create_user: "Buat pengguna",
    role: "Peran",
    staff: "Staf",
    unit_scope: "Unit sekolah yang ditangani",
    unit_scope_hint: "Kosongkan semua untuk semua unit. Jika ada unit yang dicentang, Admin ini hanya dapat meng-assign aset unit tersebut dan hanya di-CC pada persetujuan unit itu.",
    admin: "Resources Admin",
    staff_view_only: "Hanya lihat. Anda hanya dapat melaporkan kerusakan dan meminta transfer untuk aset yang di-assign kepada Anda, serta meminjam aset bersama (Shared) yang tidak dipegang personal oleh orang lain.",
    super_admin: "Super Admin",
    ict_admin: "Admin ICT",
    campus_admin: "Admin Kampus",
    leader: "Leader (hanya lihat)",
    col_name: "Nama",
    col_joined: "Bergabung",
    col_actions: "Tindakan",
    cant_delete_self: "Anda tidak dapat menghapus diri sendiri",

    // Reports
    analytics: "Analitik",
    reports: "Laporan",
    reports_soon: "Laporan segera hadir",
    reports_sub: "Ringkasan aset, laporan penyusutan, dan alat ekspor akan tersedia di sini.",
    report_download_xlsx: "Unduh (.xlsx)",
    report_downloading: "Mengunduh…",
    report_asset_inventory: "Inventaris Aset",
    report_asset_inventory_desc: "Daftar lengkap semua aset dengan kategori, kampus, ruangan, status, pemilik, dan nilai buku saat ini.",
    report_depreciation: "Jadwal Penyusutan",
    report_depreciation_desc: "Rincian penyusutan per aset — tahunan, akumulasi, dan nilai buku saat ini.",
    report_faults: "Laporan Kerusakan",
    report_faults_desc: "Semua laporan kerusakan dengan status, tingkat keparahan, pelapor, dan catatan penyelesaian.",
    report_compliance: "Daftar Kepatuhan",
    report_compliance_desc: "Semua pemeriksaan kepatuhan dengan tanggal jatuh tempo, status, dan kategori.",
    report_fully_depreciated: "Aset Habis Disusutkan",
    report_fully_depreciated_desc: "Aset yang masih dipakai tetapi sudah melewati umur manfaatnya — kandidat untuk ditinjau atau diganti.",
    life_hint: "Saran untuk kategori ini: {n} tahun. Dapat diubah.",
    report_ownership: "Riwayat Kepemilikan",
    report_ownership_desc: "Jejak audit lengkap perubahan kepemilikan aset di kedua kampus.",

    // Activity logs
    audit: "Audit",
    activity_logs: "Log Aktivitas",
    logs_soon: "Log aktivitas segera hadir",
    logs_sub: "Jejak audit lengkap semua perubahan aset, alih kepemilikan, dan tindakan pengguna akan tersedia di sini.",
    log_all: "Semua aktivitas",
    log_all_actions: "Semua tindakan",
    log_all_entities: "Semua entitas",
    log_asset_created: "Aset didaftarkan",
    log_ownership_transfer: "Alih kepemilikan",
    log_fault_reported: "Kerusakan dilaporkan",
    log_fault_resolved: "Kerusakan diselesaikan",
    log_compliance_added: "Kepatuhan ditambahkan",
    log_user_created: "Pengguna dibuat",
    log_by: "oleh",
    log_to: "→",
    log_load_more: "Muat lebih banyak",
    log_no_events: "Belum ada aktivitas.",
    log_campus: "Kampus",
    log_col_when: "Waktu",
    log_col_action: "Tindakan",
    log_col_entity: "Entitas",
    log_col_target: "Target",
    log_col_user: "Pengguna",
    log_col_details: "Detail",

    // Help
    support: "Dukungan",
    help_guide: "Panduan pengguna",
    documentation: "Dokumentasi",
    help_subtitle: "Referensi cepat untuk tugas sehari-hari di Registri Aset Sekolah YPJ. Klik topik apa pun di daftar isi untuk langsung menuju bagian tersebut.",
    help_toc_label: "Di halaman ini",
    help_need_help_title: "Butuh bantuan lebih?",
    help_need_help_body: "Hubungi administrator sekolah atau tim operasional untuk perubahan akun dan pertanyaan kebijakan.",

    help_s1_title: "Memulai",
    help_s2_title: "Membaca dasbor",
    help_s3_title: "Mendaftarkan aset baru",
    help_s4_title: "Mencari & memfilter aset",
    help_s5_title: "Mengalihkan kepemilikan",
    help_s6_title: "Melaporkan & menyelesaikan kerusakan",
    help_s7_title: "Melacak kepatuhan",
    help_s8_title: "Garansi & penyusutan",
    help_s9_title: "Mengelola pengguna (admin)",
    help_s10_title: "Foto & lampiran PDF",

    help_s1_intro: "Selamat datang di Registri Aset Sekolah YPJ. Sistem ini memberi setiap staf satu tampilan waktu nyata atas aset sekolah — dari laptop dan proyektor sampai furnitur dan kendaraan — serta menangani serah terima, peminjaman peralatan, pemesanan lab, dan persetujuan BYOD siswa. Saat pertama kali masuk Anda wajib membaca dan mengonfirmasi kebijakan sekolah (lihat \"Kebijakan dan masuk pertama kali\").",
    help_s1_roles_heading: "Peran Anda menentukan apa yang dapat dilakukan:",
    help_s1_role_admin: "Super Admin / Admin — mengelola aset, pengguna, dan kepatuhan. Super Admin juga mengelola akun Admin dan seluruh modul peminjaman.",
    help_s1_role_staff: "Staf (guru) — melihat aset kampus Anda, mengonfirmasi serah terima, melaporkan kerusakan, meminjam peralatan, memesan lab, dan membuat permohonan BYOD untuk siswa.",
    help_s1_role_ict: "Admin ICT — penanggung jawab (PIC) peralatan ICT di SATU kampus: mengonfirmasi peminjaman, menyerahkan dan menerima peralatan, mengelola cart, lab, jadwal tetap, dan persetujuan BYOD.",
    help_s1_role_leader: "Leader — hanya dapat melihat semuanya, termasuk dasbor dan laporan peminjaman. Leader tidak dapat membuat atau mengubah apa pun.",

    help_s2_intro: "Dasbor adalah halaman utama setelah masuk. Ini menampilkan empat kartu KPI di bagian atas:",
    help_s2_kpi1: "Total Aset — jumlah setiap catatan aktif.",
    help_s2_kpi2: "Nilai Buku Saat Ini — nilai inventaris Anda hari ini, setelah penyusutan.",
    help_s2_kpi3: "Akumulasi Penyusutan — berapa banyak nilai yang telah dihapusbukukan (metode garis lurus).",
    help_s2_kpi4: "Kerusakan Terbuka — laporan kerusakan yang belum diselesaikan.",
    help_s2_outro: "Grafik menampilkan proyeksi nilai buku 6 tahun. Panel kanan mencantumkan aset yang garansinya akan habis (atau sudah habis) dalam 60 hari — klik item mana saja untuk membukanya.",

    help_s3_step1: "Klik Aset di bilah samping, lalu Tambah aset.",
    help_s3_step2: "Isi Bagian 01 — Informasi Dasar: nama, tag aset, kategori, lokasi, status, dan pemilik awal.",
    help_s3_step3: "Di Bagian 02 — Keuangan & Garansi, masukkan harga beli, tanggal pembelian, umur manfaat (dalam tahun), dan tanggal akhir garansi. Penyusutan dihitung otomatis menggunakan metode garis lurus.",
    help_s3_step4: "Di Bagian 03 — Foto & Dokumen, klik kotak foto untuk mengunggah gambar aset, dan kotak dokumen untuk melampirkan PDF (faktur, manual, sertifikat).",
    help_s3_step5: "Klik Buat aset.",

    help_s4_intro: "Halaman Aset mendukung pemfilteran lanjutan:",
    help_s4_tip1: "Kotak pencarian mencocokkan nama aset, tag, atau nomor seri (langsung saat Anda mengetik).",
    help_s4_tip2: "Gunakan dropdown Kategori untuk memfilter berdasarkan Peralatan IT, Furnitur, Lab, Kendaraan, dll.",
    help_s4_tip3: "Gunakan dropdown Kampus untuk menampilkan satu kampus saja.",
    help_s4_tip4: "Gunakan dropdown Status untuk menampilkan item Aktif, Dalam Perbaikan, Pensiun, atau Hilang saja.",
    help_s4_outro: "Klik baris mana saja untuk membuka halaman detail aset lengkap.",

    help_s5_intro: "Untuk memberikan aset kepada orang lain (atau memindahkannya antar pemilik), Admin memakai Transfer di halaman aset, atau serah terima massal di halaman Pengguna / Kelas:",
    help_s5_step1: "Buka halaman detail aset lalu klik Transfer (atau pilih beberapa aset dan gunakan serah terima massal).",
    help_s5_step2: "Pilih penerima. Penerima harus pengguna yang sudah terdaftar.",
    help_s5_step3: "Penerima mendapat email dan melihat serah terima di Aset Saya. Aset baru berpindah pemilik setelah penerima memeriksa dan mengonfirmasi penerimaan; penerima juga dapat menolak dengan alasan.",
    help_s5_step4: "Penerima yang belum menyetujui kebijakan sekolah tidak dapat menerima aset: konfirmasi kebijakan terlebih dahulu.",
    help_s5_note: "Serah terima kelas bekerja dengan cara yang sama: guru penanggung jawab memeriksa setiap barang di ruangan lalu mengonfirmasi atau melaporkan perbedaan. Jejak kepemilikan lengkap tersimpan di tab Kepemilikan.",

    help_s6_intro: "Siapa pun dapat melaporkan kerusakan dari halaman detail aset (tombol Laporkan kerusakan) atau dari halaman Kerusakan.",
    help_s6_workflow_heading: "Setiap kerusakan memiliki alur status:",
    help_s6_status1: "Terbuka — baru dilaporkan.",
    help_s6_status2: "Dalam Proses — seseorang telah mulai mengerjakannya.",
    help_s6_status3: "Diselesaikan — sudah diperbaiki; catatan penyelesaian dapat ditambahkan.",
    help_s6_actions: "Tindakan halaman Kerusakan: Tandai dalam proses memajukan kerusakan Terbuka; Selesaikan menutupnya dengan catatan opsional.",

    help_s7_intro: "Gunakan bagian Kepatuhan untuk persyaratan regulasi berulang — resertifikasi alat pemadam kebakaran, inspeksi keselamatan bus sekolah, kalibrasi lab, audit, dll.",
    help_s7_tip1: "Admin membuat pemeriksaan dengan judul, kategori, tanggal jatuh tempo, dan frekuensi (Sekali, Bulanan, Triwulanan, Tahunan).",
    help_s7_tip2: "Item dikelompokkan berdasarkan status: Terlambat, Menunggu, Selesai.",
    help_s7_tip3: "Item yang terlambat ditandai secara otomatis di dasbor untuk tindakan.",

    help_s8_warranty: "Peringatan garansi muncul di dasbor untuk aset yang garansinya telah habis atau akan habis dalam 60 hari. Klik peringatan untuk membuka aset dan merencanakan pembaruan atau penggantian.",
    help_s8_dep_intro: "Penyusutan dihitung otomatis menggunakan metode garis lurus:",
    help_s8_outro: "Anda akan melihat angka langsung — tahunan, akumulasi, dan nilai buku saat ini — di setiap halaman detail aset.",

    help_s9_intro: "Admin dapat mengundang pengguna tanpa batas dari halaman Pengguna:",
    help_s9_step1: "Klik Tambah pengguna.",
    help_s9_step2: "Isi nama, email, peran (Staf, Admin ICT, Leader, Admin, atau Super Admin), kampus, departemen, dan nomor WhatsApp. Admin ICT wajib memiliki kampus. Anda juga dapat mengimpor banyak pengguna dari spreadsheet.",
    help_s9_step3: "Klik Buat. Pengguna menerima tautan untuk mengatur kata sandinya sendiri. Saat masuk pertama kali, mereka diminta mengonfirmasi kebijakan.",
    help_s9_note: "Untuk menghapus pengguna, klik ikon tong sampah di baris mereka. Anda tidak dapat menghapus akun Anda sendiri.",

    help_s10_intro: "Setiap aset dapat memiliki satu foto dan lampiran PDF/dokumen tanpa batas. File disimpan dengan aman di penyimpanan cloud dan hanya pengguna yang terautentikasi yang dapat mengaksesnya.",
    help_s10_tip1: "Tambah — unggah saat Tambah/Edit aset (Bagian 03).",
    help_s10_tip2: "Lihat — foto muncul di header Detail Aset. Dokumen muncul di tab Dokumen.",
    help_s10_tip3: "Unduh — klik ikon unduh di samping dokumen mana saja.",

    // Help: policies, loans, schedule, QR, BYOD
    help_s11_title: "Kebijakan dan masuk pertama kali",
    help_s11_intro: "Saat pertama kali masuk (dan setiap kali kebijakan berubah), sebuah jendela meminta Anda membaca semua kebijakan sekolah dan mengonfirmasinya. Anda tidak dapat memakai sistem sebelum melakukannya.",
    help_s11_step1: "Gulir sampai akhir kebijakan — bagian konfirmasi baru terbuka setelah itu.",
    help_s11_step2: "Centang tiga pernyataan: sudah membaca aturan, akan mematuhi, dan menerima sanksi.",
    help_s11_step3: "Ketik nama lengkap persis seperti di akun Anda, lalu klik \"Saya setuju dan tanda tangan\". Tanggal, jam, versi kebijakan, dan perangkat dicatat sebagai tanda tangan elektronik Anda.",
    help_s11_note: "Tanpa konfirmasi ini Anda tidak dapat meminjam peralatan atau menerima aset. Sanksi mencakup hilangnya hak akses ke aset sekolah serta kewajiban memperbaiki, mengganti, atau memberi ganti rugi atas aset yang rusak atau hilang karena kelalaian. Anda dapat membaca ulang kebijakan kapan saja di menu Kebijakan; Admin dapat melihat siapa yang sudah mengonfirmasi dan mengekspor daftarnya di sana.",
    help_s12_title: "Meminjam peralatan",
    help_s12_intro: "Gunakan Permintaan peminjaman untuk meminjam peralatan ICT dan media. Buka tab Pinjam:",
    help_s12_step1: "Untuk satu barang tertentu (kamera, mikrofon, …): cari barangnya lalu klik Minta peminjaman. Pilih waktu mulai dan selesai, tujuan, dan setujui pernyataan tanggung jawab.",
    help_s12_step2: "Untuk laptop atau iPad di luar jadwal tetap: pakai \"Pinjam laptop\" / \"Pinjam iPad\" dan cukup isi BERAPA yang dibutuhkan serta kapan. Anda boleh meminjam lebih dari satu perangkat. Admin ICT yang memilih perangkat mana yang dipinjamkan dari yang masih tersedia. Kotak hijau/merah di bawah waktu menunjukkan jumlah yang tersedia pada jam itu; jika 0, baris di bawahnya menjelaskan sebabnya (terdaftar, dipinjam, atau ditahan jadwal kelas cart). Akun admin tanpa kampus sendiri memilih kampus terlebih dahulu.",
    help_s12_step3: "Admin ICT mengonfirmasi pengajuan (permintaan bawa pulang perlu supervisor Anda lebih dulu). Anda menerima email berisi keputusan. Laptop dan iPad tetap berada di kampus.",
    help_s12_step4: "Ambil peralatan di ruang ICT. Admin ICT mencatat kondisi, daftar kelengkapan, dan foto sebelum. Serah terima dan pengembalian dapat dilakukan dari halaman Scan peminjaman.",
    help_s12_step5: "Kembalikan tepat waktu. Pengingat dikirim lewat email sebelum tanggal pengembalian; peminjaman yang melewati waktu selesai ditandai Terlambat dan menghalangi pengajuan baru sampai dikembalikan.",
    help_s12_step6: "Saat pengembalian, Admin ICT memeriksa kondisi lagi dengan foto sesudah. Kerusakan atau kehilangan otomatis membuat laporan kerusakan.",
    help_s12_note: "Aturan: ajukan paling cepat H-14 dan paling lambat H-1 (bawaan, dapat diubah ICT), tidak pada hari libur sekolah, dan hanya untuk kampus Anda. Foto otomatis dikecilkan maksimal 50 KB per foto: satu sebelum dan satu sesudah per perangkat. Pengajuan Anda dan statusnya ada di Pinjaman saya.",
    help_s12_ict: "Admin ICT: buka pengajuan di Perlu dikonfirmasi / ditangani. Untuk permintaan laptop/iPad, pilih tepat sebanyak perangkat yang Anda setujui (hanya perangkat yang benar-benar bebas pada waktu itu yang ditampilkan). Persetujuan mengunci perangkat tersebut; saat serah terima Anda dapat melewatkan sebagian atau menukar dengan perangkat bebas lain. Atur jumlah maksimal perangkat per permintaan di Jadwal & lab › Pengaturan jadwal.",
    help_s13_title: "Jadwal, cart, dan lab",
    help_s13_intro: "Jadwal & lab menampilkan kalender mingguan cart laptop, cart iPad, dan Lab Komputer per jam pelajaran. Hijau berarti unit masih tersedia, merah berarti terpakai penuh. Jadwal kelas tetap selalu didahulukan.",
    help_s13_tip1: "Guru: klik slot yang masih kosong untuk meminta waktu tambahan di luar jadwal tetap (jumlah unit dan jam pelajaran).",
    help_s13_tip2: "Admin ICT: di Pengaturan jadwal, tambahkan cart dan lab beserta unitnya, jam pelajaran, libur sekolah, jadwal kelas tetap, dan pasangkan setiap tablet atau laptop dengan siswa untuk satu semester.",
    help_s13_tip3: "Untuk sesi jadwal tetap, Admin ICT memulai serah terima dari kalender: seluruh cart diserahkan sekaligus, pengecualian dicatat, dengan satu foto bersama.",
    help_s13_tip4: "Peminjaman di luar jadwal mengikuti kalender: selama sesi kelas menahan sebuah cart, unitnya tampil \"Terpakai (terjadwal)\" di daftar peminjaman dan halaman scan, dan peminjaman satu unit hanya bisa memakai sisa yang tidak dipakai jadwal. Unit yang dipinjam sendiri juga mengambil satu tempat di cart-nya.",
    help_s14_title: "Label barcode dan pemindaian",
    help_s14_intro: "Setiap aset dapat diberi label barcode. Admin ICT dan Admin mencetak label dari Scan peminjaman › Cetak label barcode (barcode baris panjang, dua kolom, mudah dipindai bahkan dari layar komputer) lalu menempelkannya pada peralatan. Ada dua halaman scan: Scan peminjaman dan Scan aset. Keduanya membaca barcode dan QR lewat kamera atau scanner barcode USB, dan menerima kode aset atau nomor seri yang diketik.",
    help_s14_tip1: "Scan peminjaman: menampilkan status aset. Untuk unit yang dipinjam sendiri, langsung menuju serah terima atau pengembalian. Untuk unit cart saat sesi kelas berjalan, tampil sesi jadwalnya (kelas, guru, jam) dan tombol \"Serah terima sesi jadwal\" yang membuka check-out sesi tersebut.",
    help_s14_tip2: "Status \"Terpakai (terjadwal)\" berarti jadwal tetap atau booking sedang menahan cart saat ini, dan baris \"Cart G: 20 / 22 unit sedang dipakai jadwal\" menunjukkan jumlahnya. Tombol \"Pinjam aset ini\" hanya muncul bila aset tersedia.",
    help_s14_tip3: "Scan aset: membuka aset yang sudah terdaftar (lihat atau ubah). Bila kodenya belum terdaftar, \"Daftarkan sebagai aset baru\" membuka formulir aset baru dengan kode yang sudah terisi.",
    help_s14_tip4: "Jika kamera tidak tersedia, ketik kode aset (misalnya YPJ-KAM-005) atau nomor seri. Spasi dan huruf besar/kecil tidak berpengaruh.",
    help_s14_tip5: "Untuk cart atau lab, pindai unit satu per satu untuk menandainya saat serah terima atau pengembalian.",
    help_s14_tip6: "Guru meminjam beberapa laptop / iPad di luar jadwal: di Scan peminjaman centang \"Pinjamkan beberapa unit sekaligus\", scan tiap unit ke keranjang, pilih peminjam dan jam kembali, lalu \"Buat satu peminjaman\". Semua unit menjadi SATU peminjaman. Tambahkan satu foto bersama semua unit untuk langsung menyerahkan semuanya pada langkah yang sama (tercatat kondisi baik); tanpa foto, selesaikan serah terima (kondisi, foto) di halaman peminjaman. Hanya laptop / iPad yang tersedia yang bisa ditambahkan, dan tidak boleh dicampur.",
    help_s15_title: "BYOD siswa (perangkat pribadi)",
    help_s15_intro: "Siswa boleh membawa laptop, iPad, atau tablet pribadi (bukan ponsel) untuk project, dalam periode yang ditetapkan guru pendamping. Urutan persetujuan: orang tua, lalu guru, lalu ICT. Buka BYOD Siswa.",
    help_s15_step1: "Guru: klik Project BYOD baru. Isi project, tanggal (maksimal sekitar 3 bulan), jam yang diizinkan, lalu tambahkan siswa beserta email atau nomor WhatsApp orang tua.",
    help_s15_step2: "Setiap orang tua menerima tautan sekali pakai (berlaku 7 hari), membaca ketentuan, mengisi data perangkat dan MAC address, lalu tanda tangan dengan jari. Tidak perlu akun. Jika pesan tidak sampai, salin tautan atau gunakan Kirim ulang tautan.",
    help_s15_step3: "Setelah orang tua menandatangani, guru menandatangani di aplikasi (ketik nama dan gambar tanda tangan).",
    help_s15_step4: "Admin ICT kampus memeriksa perangkat, dapat mengoreksi MAC address, lalu menyetujui atau menolak. Setelah disetujui, daftarkan MAC address ke WiFi sekolah (ekspor lewat Ekspor perangkat aktif).",
    help_s15_note: "Maksimal 2 perangkat per siswa dan satu MAC address hanya dapat didaftarkan sekali. Guru dapat meminta satu kali perpanjangan (harus disetujui ICT). ICT dapat mencabut akses kapan saja. Guru dan ICT diingatkan 3 hari sebelum berakhir. Formulir yang sudah ditandatangani dapat dicetak atau disimpan sebagai PDF dari halaman permohonan.",
    help_fig_hero: "YPJ Assets berjalan di browser apa pun: laptop, tablet, dan HP.",
    help_fig_policy: "Jendela kebijakan yang dikonfirmasi saat pertama kali masuk.",
    help_fig_dashboard: "Dasbor: total aset, nilai buku, penyusutan, dan kerusakan terbuka.",
    help_fig_asset_new: "Formulir Tambah aset: identitas, keuangan, serta foto & dokumen.",
    help_fig_assets: "Daftar aset dengan pencarian dan filter.",
    help_fig_asset_detail: "Halaman aset dengan Laporkan kerusakan, Alihkan, dan Edit.",
    help_fig_my_assets: "Aset Saya di HP: periksa barangnya lalu ketuk Terima atau Tolak.",
    help_fig_borrow: "Tab Pinjam: pilih peralatan, atau minta N laptop / iPad.",
    help_fig_borrow_dialog: "Pinjam laptop: cukup isi jumlah dan waktunya.",
    help_fig_loan_detail: "Admin ICT mengonfirmasi pengajuan dan memilih perangkat yang bebas.",
    help_fig_schedule: "Kalender mingguan: hijau = unit tersedia, merah = terpakai penuh.",
    help_fig_scan: "Scan peminjaman: pindai barcode atau ketik kode aset.",
    help_fig_byod_sign: "Orang tua menandatangani di HP dengan jari, tanpa akun.",
    help_fig_byod_detail: "Halaman permohonan menampilkan alur persetujuan: orang tua, guru, ICT.",
    help_fig_faults: "Daftar kerusakan dengan status dan tindakan.",
    help_fig_compliance: "Pemeriksaan kepatuhan dengan jatuh tempo; yang terlambat ditandai.",
    help_fig_users: "Tim & pengguna: peran, kampus, dan impor massal.",
    help_fig_zoom: "Klik gambar untuk memperbesar",

    // Policies page
    pol_section: "Tata Kelola",
    pol_title: "Kebijakan & Prosedur",
    pol_subtitle: "Kebijakan resmi YPJ yang mengatur perilaku staf, penggunaan aset, dan pengelolaan data.",
    pol_toc: "Daftar isi",
    pol_effective: "Berlaku",
    pol_effective_date: "Versi 2026.1 — Tahun Ajaran 2026–2027. Ditinjau setiap tahun oleh Administrasi Sekolah YPJ. Setiap pengguna wajib mengonfirmasi ulang kebijakan setiap kali versi baru diterbitkan.",
    pol_questions: "Ada pertanyaan?",
    pol_questions_body: "Hubungi administrator sekolah atau departemen TIK untuk klarifikasi kebijakan apa pun.",

    pol_tag_ict: "TIK",
    pol_tag_asset: "Manajemen Aset",
    pol_tag_data: "Data & Privasi",
    pol_tag_admin: "Administrasi",

    // RUP
    pol_rup_title: "Kebijakan Penggunaan yang Bertanggung Jawab (RUP) — Sumber Daya TIK",
    pol_rup_purpose_h: "Ikhtisar",
    pol_rup_purpose: "Kebijakan Penggunaan yang Bertanggung Jawab atas sumber daya Teknologi Informasi dan Komunikasi (TIK) diringkas di bawah ini. Silakan gunakan ini sebagai panduan untuk penggunaan sistem TIK dan Internet yang dapat diterima di sekolah dan di luar kampus.",
    pol_rup_scope_h: "Cakupan Sumber Daya Teknologi YPJ",
    pol_rup_scope: "Semua sumber daya teknologi YPJ: desktop, laptop, iPad, mesin fotokopi, printer, aplikasi, email, Internet, Intranet, SharePoint, sumber daya jaringan, peralatan audio/visual, dan teknologi terkait milik PTFI & YPJ dan dipinjamkan kepada saya sebagai karyawan.",
    pol_rup_acceptable_h: "Penggunaan yang Dapat Diterima",
    pol_rup_acceptable: "Penggunaan teknologi YPJ adalah untuk tujuan pendidikan dan hanya untuk pekerjaan sekolah terkait YPJ.||Penggunaan teknologi YPJ adalah hak istimewa; perawatan peralatan adalah tanggung jawab saya.||Saya akan menjaga sumber daya teknologi YPJ aman setiap saat dan tidak akan meminjamkannya kepada teman atau anggota keluarga.||Saya bertanggung jawab atas pencadangan dan pemulihan data saya yang disimpan pada sumber daya teknologi YPJ.||Semua informasi yang disalin dan digunakan akan dirujuk dengan tepat oleh penulis, sumber, tanggal publikasi, dan/atau tautan situs web.",
    pol_rup_prohibited_h: "Kegiatan yang Dilarang",
    pol_rup_prohibited: "Saya tidak akan menginstal perangkat lunak, menghapus program, atau menggunakan metode konfigurasi apa pun untuk mengubah pengaturan asli peralatan.||Saya tidak akan mengambil sumber daya teknologi YPJ dari lokasi kerja (kecuali diberi izin tertulis oleh Supervisor saya).||Sesuai dengan kebijakan FMI MIS, saya tidak akan mengungkapkan kata sandi login saya kepada orang lain.||Melihat atau mendistribusikan materi pornografi, cabul, atau yang menghina orang lain tidak akan ditoleransi.||Semua bentuk intimidasi dunia maya (melecehkan, menggoda, mengintimidasi, mengancam, mengirim/memposting pesan yang tidak pantas melalui email, obrolan, pesan teks, WhatsApp, gambar, atau situs web) tidak dapat diterima.||Hindari penggunaan surat berantai dan hanya mengirim email ke grup besar bila perlu.||Mengunduh dan streaming file besar untuk penggunaan non-instruksional dilarang.||Sumber daya teknologi YPJ tidak dapat digunakan untuk keuntungan pribadi atau kegiatan politik.||Saya tidak akan mengambil gambar, video, atau rekaman audio orang lain tanpa persetujuan mereka.||Saya tidak akan mendistribusikan rekaman gambar, video, atau audio orang lain melalui email, SMS, WhatsApp, media sosial, atau platform lain tanpa persetujuan mereka.",
    pol_rup_breach_h: "Konsekuensi Penggunaan yang Tidak Pantas",
    pol_rup_breach: "Pelanggaran terhadap kebijakan ini dapat mengakibatkan hilangnya hak akses internet dan/atau hak penggunaan komputer. Pelanggaran serius dapat menyebabkan penangguhan atau pemberhentian. Saya akan membayar jumlah biaya yang sesuai (hingga biaya penggantian penuh) jika laptop atau iPad yang dipinjamkan perlu diperbaiki atau diganti karena kelalaian, kehilangan, pencurian, atau kecelakaan.",

    // Asset Care
    pol_care_title: "Kebijakan Perawatan & Pemeliharaan Aset",
    pol_care_purpose_h: "Tujuan",
    pol_care_purpose: "Kebijakan ini memastikan semua aset sekolah dirawat dengan baik, dijaga dalam kondisi prima, dan setiap masalah dilaporkan segera untuk mempertahankan nilai inventaris YPJ.",
    pol_care_obligations_h: "Kewajiban Staf",
    pol_care_obligations: "Tangani semua aset yang diberikan dengan perawatan yang wajar sesuai panduan produsen.||Simpan aset dengan aman saat tidak digunakan dan lindungi dari kerusakan, pencurian, atau kehilangan.||Laporkan kerusakan, malfungsi, atau penurunan kondisi segera melalui halaman Kerusakan di sistem ini.||Jangan mencoba perbaikan atau modifikasi tanpa izin pada aset sekolah mana pun.||Kembalikan aset ke lokasi yang benar setelah digunakan.",
    pol_care_damage_h: "Kerusakan & Kehilangan",
    pol_care_damage: "Kerusakan yang tidak disengaja harus dilaporkan dalam 24 jam melalui halaman Kerusakan. Kerusakan atau kehilangan akibat kelalaian, penyalahgunaan, atau tidak melapor dapat mengakibatkan staf bertanggung jawab secara finansial atas biaya perbaikan atau penggantian penuh, dan/atau kehilangan hak akses ke aset sekolah, sebagaimana ditentukan oleh administrasi sekolah (lihat Sanksi & Tanggung Jawab).",
    pol_care_reporting_h: "Pelaporan",
    pol_care_reporting: "Semua kerusakan harus dicatat dalam sistem melalui tombol Laporkan Kerusakan pada halaman aset yang bersangkutan. Ini membuat catatan yang dapat diaudit dan memungkinkan tim pemeliharaan merespons dengan cepat.",

    // Loan & Transfer
    pol_loan_title: "Kebijakan Peminjaman, Pemesanan Jadwal & Alih Kepemilikan Aset",
    pol_loan_purpose_h: "Tujuan",
    pol_loan_purpose: "Kebijakan ini mengatur peminjaman, penjadwalan, dan transfer aset sekolah antar staf dan lokasi, memastikan akuntabilitas dan keterlacakan yang tepat setiap saat. Peralatan ICT dan media diproses melalui modul Peminjaman; cart, lab, dan ruangan dipesan melalui Jadwal.",
    pol_loan_eligibility_h: "Kelayakan",
    pol_loan_eligibility: "Semua staf tetap dan kontrak berhak mengajukan peminjaman, pemesanan, atau transfer aset.||Permintaan harus dilakukan melalui sistem Manajemen Aset Sekolah, bukan lewat telepon, pesan, atau kesepakatan lisan.||Aset hanya boleh digunakan untuk keperluan sekolah.||Staf hanya dapat mengajukan aset di kampus yang ditugaskan kepada mereka. Peralatan hanya boleh dibawa keluar kampus jika aturan kategorinya mengizinkan dan telah dikonfirmasi ICT Admin.||Permintaan harus diajukan paling lambat sesuai batas pemberitahuan minimum dan tidak lebih awal dari batas maksimum yang ditetapkan untuk kategori tersebut (bawaan: H-1 sampai H-14).",
    pol_loan_process_h: "Proses Pengajuan",
    pol_loan_process: "Buka aset (atau cart, lab, ruangan) di sistem dan ajukan permintaan peminjaman, pemesanan, atau transfer dengan tujuan serta tanggal/jam pelajaran yang jelas.||Sistem memeriksa ketersediaan dan bentrokan jadwal. Permintaan kemudian dikonfirmasi oleh atasan bila diperlukan dan oleh ICT Admin (PIC) kampus untuk kategori ICT.||Saat serah terima, ICT Admin mencatat kondisi aset, daftar kelengkapan, dan foto; Anda wajib memeriksa aset dan segera melaporkan jika ada perbedaan.||Serah terima dan pengembalian dapat dilakukan dengan memindai label QR pada aset.||Kembalikan aset sesuai waktu yang disepakati. Email pengingat dikirim sebelum tanggal pengembalian; peminjaman yang melewati waktu selesai ditandai Terlambat.||Saat pengembalian, ICT Admin memeriksa kembali kondisi dan kelengkapan lalu mencatatnya dengan foto. Peminjaman baru dinyatakan selesai setelah pemeriksaan ini.",
    pol_loan_return_h: "Pengembalian & Akuntabilitas",
    pol_loan_return: "Aset harus dikembalikan dalam kondisi yang sama seperti saat diterima, lengkap dengan aksesorinya. Keterlambatan pengembalian harus dikomunikasikan kepada administrator terlebih dahulu. Peminjaman yang terlambat ditandai di sistem dan dapat menghalangi pengajuan berikutnya. Kondisi dan foto yang dicatat saat serah terima dan pengembalian menjadi acuan untuk menentukan tanggung jawab atas kerusakan atau kehilangan. Semua waktu di sistem memakai WIT (UTC+9).",

    // Data & Privacy
    pol_privacy_title: "Kebijakan Perlindungan Data & Privasi",
    pol_privacy_purpose_h: "Tujuan",
    pol_privacy_purpose: "YPJ berkomitmen untuk melindungi data pribadi staf, siswa, dan orang tua. Kebijakan ini menguraikan bagaimana data dalam sistem Manajemen Aset Sekolah dikumpulkan, disimpan, dan digunakan.",
    pol_privacy_principles_h: "Prinsip Utama",
    pol_privacy_principles: "Data dikumpulkan hanya untuk keperluan manajemen sekolah yang sah.||Akses ke sistem dibatasi untuk staf yang berwenang dengan kredensial yang valid.||Staf tidak boleh berbagi kredensial login atau mengakses akun orang lain.||Data sistem tidak boleh diekspor, dibagikan, atau didistribusikan di luar saluran resmi sekolah.||YPJ berhak untuk memantau aktivitas sistem untuk tujuan keamanan dan kepatuhan.",
    pol_privacy_access_h: "Kontrol Akses",
    pol_privacy_access: "Pengguna Admin memiliki akses penuh ke semua catatan. Pengguna Staf hanya dapat melihat dan bertindak pada aset di kampus yang ditugaskan. Semua tindakan sistem dicatat untuk tujuan audit.",
    pol_privacy_breach_h: "Pelanggaran Data",
    pol_privacy_breach: "Dugaan pelanggaran data, akses tidak sah, atau insiden keamanan apa pun harus segera dilaporkan kepada administrator sekolah dan departemen TIK. Jangan mencoba menyelidiki atau menyelesaikan pelanggaran secara mandiri.",

    // Inventory Management
    pol_inv_title: "Kebijakan Manajemen Inventaris",
    pol_inv_purpose_h: "Tujuan",
    pol_inv_purpose: "Kebijakan ini memastikan sistem Manajemen Aset Sekolah tetap menjadi catatan yang akurat dan terkini dari semua aset YPJ, mendukung manajemen keuangan dan akuntabilitas yang baik.",
    pol_inv_register_h: "Persyaratan Pendaftaran Aset",
    pol_inv_register: "Semua aset baru harus didaftarkan di sistem sebelum digunakan.||Setiap aset harus memiliki tag aset unik, kategori, kampus, dan pemilik atau lokasi yang ditugaskan.||Informasi keuangan (harga beli, tanggal, masa manfaat) harus dicatat dengan akurat untuk perhitungan penyusutan.||Foto dan dokumen pendukung (faktur, garansi) sebaiknya dilampirkan bila tersedia.||Aset sebaiknya diberi label QR agar dapat dipindai untuk serah terima, pengembalian, dan audit.",
    pol_inv_audit_h: "Audit Berkala",
    pol_inv_audit: "Administrasi sekolah akan melakukan audit fisik aset setidaknya sekali per tahun ajaran. Staf wajib bekerja sama sepenuhnya, mengonfirmasi lokasi dan kondisi aset yang ditugaskan kepada mereka (termasuk saat aset diserahkan kepada mereka), dan segera melaporkan ketidaksesuaian.",
    pol_inv_disposal_h: "Pelepasan & Pensiun Aset",
    pol_inv_disposal: "Aset yang tidak dapat lagi digunakan harus diperbarui ke status Pensiun dalam sistem oleh admin. Pelepasan fisik harus mengikuti prosedur pelepasan aset YPJ dan PTFI dan tidak boleh dilakukan tanpa persetujuan tertulis dari kepala sekolah.",

    // Sanctions & Liability
    pol_sanction_title: "Kebijakan Sanksi & Tanggung Jawab",
    pol_tag_sanction: "Sanksi",
    pol_sanction_purpose_h: "Tujuan",
    pol_sanction_purpose: "Kebijakan ini menetapkan konsekuensi jika pengguna melanggar kebijakan di atas atau jika aset sekolah yang berada dalam tanggung jawabnya rusak atau hilang. Dengan mengonfirmasi kebijakan di sistem ini, setiap pengguna menerima konsekuensi tersebut.",
    pol_sanction_access_h: "Kehilangan Hak Akses",
    pol_sanction_access: "Pelanggaran kebijakan apa pun, keterlambatan pengembalian berulang, kerusakan atau kehilangan yang tidak dilaporkan, atau penyalahgunaan aset dapat berujung pada peringatan, penangguhan sementara, atau hilangnya hak untuk meminjam, memesan, atau dipercayakan aset sekolah secara permanen.||Akses ke sistem dan sumber daya ICT dapat dibatasi selama kasus ditinjau.||Pelanggaran serius atau berulang dapat dilaporkan kepada kepala sekolah dan dapat berujung pada tindakan disipliner, termasuk penangguhan atau pemberhentian.",
    pol_sanction_liability_h: "Perbaikan, Penggantian & Ganti Rugi",
    pol_sanction_liability: "Jika aset yang ada dalam tanggung jawab atau pinjaman Anda rusak, hilang, atau dicuri karena kelalaian, penyalahgunaan, atau tidak mengikuti kebijakan ini, Anda setuju untuk membayar biaya perbaikannya, atau menggantinya dengan aset setara, atau membayar nilai penggantian hingga biaya penggantian penuh, sebagaimana ditentukan oleh administrasi sekolah.||Kerusakan tidak disengaja yang dilaporkan tepat waktu dinilai kasus per kasus.||Kondisi, foto, dan kelengkapan yang dicatat saat serah terima dan pengembalian, serta log aktivitas, diterima sebagai bukti.",
    pol_sanction_process_h: "Proses",
    pol_sanction_process: "Administrasi meninjau fakta dan memberi Anda kesempatan menjelaskan sebelum keputusan akhir diambil.||Keputusan dicatat di sistem. Jumlah yang terutang diselesaikan sesuai prosedur YPJ dan PTFI.",
    pol_sanction_esign_h: "Konfirmasi Elektronik",
    pol_sanction_esign: "Konfirmasi elektronik Anda di sistem ini (nama lengkap yang diketik, tanggal dan jam, versi kebijakan, serta informasi perangkat) dicatat sebagai pernyataan tertandatangani Anda dan berlaku sama seperti pernyataan persetujuan tertulis. Anda wajib mengonfirmasi ulang setiap kali versi baru diterbitkan.",

    // Policy acknowledgement
    polack_title: "Selamat datang — mohon baca dan konfirmasi kebijakan aset sekolah",
    polack_intro: "Sebelum menggunakan sistem Manajemen Aset Sekolah, Anda wajib membaca seluruh kebijakan di bawah ini dan menyatakan akan mematuhinya. Konfirmasi ini dicatat sebagai tanda tangan elektronik Anda.",
    polack_scroll_hint: "Gulir sampai akhir kebijakan untuk membuka kolom konfirmasi.",
    polack_scrolled: "Anda telah sampai di akhir kebijakan.",
    polack_summary_h: "Dengan mengonfirmasi, Anda menyatakan bahwa:",
    polack_s1: "Saya telah membaca dengan seksama dan memahami seluruh kebijakan serta aturan penggunaan aset sekolah.",
    polack_s2: "Saya akan mematuhi setiap aturan tentang penggunaan, peminjaman, perawatan, dan pengembalian aset sekolah.",
    polack_s3: "Saya menerima sanksi: hilangnya hak akses saya ke aset sekolah, serta memperbaiki, mengganti, atau memberi ganti rugi atas aset yang rusak atau hilang karena kelalaian saya atau karena tidak mengikuti kebijakan.",
    polack_name_label: "Tanda tangan dengan mengetik nama lengkap Anda",
    polack_name_hint: "Harus sama dengan nama akun Anda:",
    polack_name_mismatch: "Nama tidak sama dengan nama akun Anda.",
    polack_submit: "Saya setuju dan tanda tangan",
    polack_submitting: "Menyimpan…",
    polack_footer: "Konfirmasi Anda disimpan beserta tanggal dan jam, versi kebijakan, dan informasi perangkat.",
    polack_saved: "Terima kasih. Konfirmasi Anda telah dicatat.",
    polack_failed: "Konfirmasi tidak dapat disimpan. Silakan coba lagi.",
    polack_you_signed: "Anda mengonfirmasi kebijakan ini pada",
    polack_admin_title: "Konfirmasi kebijakan",
    polack_admin_signed: "pengguna sudah mengonfirmasi",
    polack_admin_pending: "pengguna belum mengonfirmasi",
    polack_export: "Ekspor Excel",
    polack_download_failed: "Gagal mengunduh.",

    // Loans module
    ln_kicker: "Peminjaman perangkat",
    ln_title: "Peminjaman ICT & Media",
    ln_subtitle: "Pinjam laptop, kamera, alat musik, dan perangkat lain. Setiap pengajuan dicek ketersediaannya, dikonfirmasi Admin ICT, dan dicatat dengan foto saat serah terima dan pengembalian.",
    ln_tab_borrow: "Pinjam",
    ln_tab_mine: "Pinjaman saya",
    ln_tab_manage: "Perlu dikonfirmasi / ditangani",
    ln_tab_all: "Semua pinjaman",
    ln_tab_loans: "Peminjaman",
    ln_search: "Cari nama, kode, merek…",
    ln_all_categories: "Semua kategori",
    ln_all_statuses: "Semua status",
    ln_no_borrowable: "Belum ada perangkat yang bisa dipinjam. Admin ICT dapat mengaktifkannya di tab Peminjaman pada setiap aset.",
    ln_request: "Ajukan peminjaman",
    ln_request_title: "Pengajuan peminjaman",
    ln_submit: "Kirim pengajuan",
    ln_submitted: "Pengajuan terkirim:",
    ln_saved: "Tersimpan",
    ln_start: "Mulai",
    ln_end: "Selesai",
    ln_purpose: "Keperluan",
    ln_class: "Kelas / peserta",
    ln_subject: "Mata pelajaran / kegiatan",
    ln_use_location: "Lokasi pemakaian",
    ln_note: "Catatan",
    ln_take_home: "Dibawa keluar sekolah (permintaan khusus)",
    ln_take_home_warn: "Aset ini biasanya tetap di sekolah. Supervisor Anda harus menyetujui lebih dulu, lalu Admin ICT.",
    ln_override: "Pengecualian aturan (Admin ICT)",
    ln_override_hint: "Alasan melewati aturan H-1 / lama pinjam",
    ln_terms: "Saya bertanggung jawab atas aset ini dan akan mengembalikannya tepat waktu dalam kondisi yang sama.",
    ln_available: "Tersedia pada waktu ini",
    ln_not_available: "Tidak tersedia pada waktu ini",
    ln_pending_others: "pengajuan lain menunggu",
    ln_policy_max: "Maks.",
    ln_days: "hari",
    ln_policy_approval: "perlu persetujuan ICT",
    ln_policy_auto: "disetujui otomatis",
    ln_policy_takehome_ok: "boleh dibawa keluar",
    ln_policy_takehome_no: "tetap di sekolah",
    ln_state_available: "Tersedia",
    ln_state_on_loan: "Dipinjam",
    ln_state_scheduled: "Terpakai (terjadwal)",
    qr_cart_used: "unit sedang dipakai jadwal",
    ln_in_use_now: "Sedang dipesan / dipakai sesuai jadwal saat ini",
    ln_state_repair: "Perbaikan",
    ln_state_lost: "Hilang",
    ln_state_inactive: "Tidak aktif",
    ln_with: "dipakai",
    ln_until: "sampai",
    ln_number: "No.",
    ln_asset: "Aset",
    ln_requester: "Pemohon",
    ln_period: "Periode",
    ln_status: "Status",
    ln_empty: "Belum ada pinjaman.",
    ln_back: "Kembali ke peminjaman",
    ln_units: "Unit",
    pool_card_title: "Pinjam laptop atau iPad (di luar jadwal tetap)",
    pool_card_hint: "Ajukan jumlah laptop atau iPad yang Anda butuhkan. Anda tidak memilih perangkat tertentu: Admin ICT yang menentukan perangkat mana yang dipinjamkan, sesuai yang masih tersedia.",
    pool_laptops: "Pinjam laptop",
    pool_ipads: "Pinjam iPad",
    pool_request_title: "Pinjam",
    pool_hint: "Anda dapat meminjam lebih dari satu perangkat. Setelah Admin ICT menyetujui, ambil perangkat yang ditetapkan untuk Anda di ruang ICT.",
    pool_units: "Jumlah perangkat",
    pool_free_now: "tersedia pada waktu ini",
    pool_campus: "Kampus",
    pool_why_none: "Belum ada perangkat jenis ini yang terdaftar dapat dipinjam di kampus Anda.",
    pool_why_total: "Terdaftar",
    pool_why_busy: "Dipinjam/dipesan",
    pool_why_cart: "Dipakai jadwal cart",
    pool_max_per_request: "Maks. per permintaan",
    pool_pick_units: "Pilih perangkat yang dipinjamkan",
    pool_pick_hint: "Hanya perangkat yang masih tersedia pada waktu ini yang ditampilkan. Pilih tepat sebanyak yang Anda setujui.",
    pool_none_free: "Tidak ada perangkat jenis ini yang tersedia pada waktu ini.",
    pool_autopick: "Pilih otomatis",
    pool_limit_title: "Batas permintaan laptop / iPad",
    pool_limit_hint: "Jumlah laptop atau iPad terbanyak yang boleh diminta guru dalam satu permintaan di kampus ini.",

    // BYOD
    nav_byod: "BYOD Siswa",
    byod_kicker: "Bring Your Own Device",
    byod_title: "Persetujuan BYOD Siswa",
    byod_subtitle: "Siswa boleh membawa laptop, iPad, atau tablet pribadi untuk mengerjakan project pada periode yang ditetapkan guru pendamping. Persetujuan berjalan: orang tua, guru, lalu ICT, sebelum perangkat mendapat WiFi sekolah.",
    byod_tab_mine: "Project saya",
    byod_tab_manage: "Antrean ICT",
    byod_tab_all: "Semua",
    byod_new: "Project BYOD baru",
    byod_export: "Ekspor perangkat aktif",
    byod_empty: "Belum ada permohonan BYOD.",
    byod_number: "No.",
    byod_student: "Siswa",
    byod_project: "Project",
    byod_period: "Periode",
    byod_status: "Status",
    byod_teacher: "Guru pendamping",
    byod_st_waiting_parent: "Menunggu orang tua",
    byod_st_waiting_teacher: "Menunggu guru",
    byod_st_waiting_ict: "Menunggu ICT",
    byod_st_approved: "Disetujui",
    byod_st_scheduled: "Disetujui (belum mulai)",
    byod_st_active: "Aktif",
    byod_st_expired: "Berakhir",
    byod_st_rejected: "Ditolak",
    byod_st_cancelled: "Dibatalkan",
    byod_st_revoked: "Akses dicabut",
    byod_new_title: "Project BYOD baru",
    byod_new_hint: "Isi data project dan siswanya. Setiap orang tua menerima tautan sekali pakai untuk membaca dan menandatangani. Periode maksimal 3 bulan.",
    byod_project_name: "Nama project / pameran",
    byod_subject: "Mata pelajaran",
    byod_location: "Tempat penggunaan",
    byod_start: "Tanggal mulai",
    byod_end: "Tanggal selesai",
    byod_hour_from: "Diizinkan mulai jam",
    byod_hour_to: "Diizinkan sampai jam",
    byod_students: "Siswa",
    byod_add_student: "Tambah siswa",
    byod_remove: "Hapus",
    byod_student_name: "Nama siswa",
    byod_student_class: "Kelas",
    byod_student_no: "No. induk",
    byod_parent_name: "Nama orang tua / wali",
    byod_parent_email: "Email orang tua",
    byod_parent_phone: "WhatsApp orang tua",
    byod_contact_hint: "Isi minimal email atau nomor WhatsApp untuk setiap orang tua.",
    byod_create: "Buat dan kirim tautan",
    byod_created_title: "Tautan dibuat",
    byod_created_hint: "Tautan dikirim lewat email / WhatsApp bila memungkinkan. Jika pesan tidak terkirim, salin tautan dan kirim sendiri. Setiap tautan hanya berlaku satu kali dan kedaluwarsa dalam 7 hari.",
    byod_copy: "Salin tautan",
    byod_copied: "Tautan disalin.",
    byod_sent_email: "email terkirim",
    byod_sent_wa: "WhatsApp terkirim",
    byod_sent_none: "belum terkirim: salin tautan",
    byod_back: "Kembali ke BYOD",
    byod_flow: "Alur persetujuan",
    byod_step_parent: "Orang tua",
    byod_step_teacher: "Guru",
    byod_step_ict: "ICT",
    byod_signed_on: "Ditandatangani",
    byod_pending: "Menunggu",
    byod_by: "oleh",
    byod_info: "Permohonan",
    byod_allowed_hours: "Jam diizinkan",
    byod_campus: "Kampus",
    byod_parent: "Orang tua / wali",
    byod_relation: "Hubungan",
    byod_devices: "Perangkat",
    byod_kind_laptop: "Laptop",
    byod_kind_ipad: "iPad",
    byod_kind_tablet: "Tablet",
    byod_brand: "Merek",
    byod_model: "Model",
    byod_os: "Sistem operasi",
    byod_os_version: "Versi OS",
    byod_mac: "MAC address WiFi",
    byod_serial: "No. seri (opsional)",
    byod_signatures: "Tanda tangan",
    byod_history: "Riwayat",
    byod_resend: "Kirim ulang tautan",
    byod_resend_done: "Tautan baru dibuat. Tautan lama tidak berlaku lagi.",
    byod_cancel: "Batalkan permohonan",
    byod_revoke: "Cabut akses",
    byod_extend: "Minta perpanjangan",
    byod_teacher_sign: "Tanda tangan guru",
    byod_decide: "Keputusan ICT",
    byod_approve: "Setujui",
    byod_reject: "Tolak",
    byod_note: "Catatan",
    byod_reason: "Alasan",
    byod_reason_required: "Alasan wajib diisi.",
    byod_new_end: "Tanggal selesai baru",
    byod_ext_hint: "Satu kali perpanjangan hingga 92 hari. Harus disetujui ICT; tidak perlu tanda tangan orang tua lagi.",
    byod_ext_pending: "Perpanjangan diminta sampai",
    byod_decide_hint: "Periksa perangkat di bawah. Anda dapat mengoreksi MAC address sebelum menyetujui. Setelah disetujui, daftarkan MAC address ke WiFi sekolah.",
    byod_teacher_sign_title: "Pernyataan guru",
    byod_teacher_statement: "Saya mendampingi project ini dan mengizinkan siswa menggunakan perangkat pribadi yang tercantum hanya untuk project, dalam periode dan jam di atas. Saya akan melaporkan penyalahgunaan kepada ICT.",
    byod_sign_name: "Ketik nama lengkap Anda",
    byod_sign_name_hint: "Harus sama dengan nama akun Anda:",
    byod_draw: "Gambar tanda tangan Anda",
    byod_clear: "Hapus",
    byod_print: "Cetak / simpan PDF",
    byod_saved: "Tersimpan.",
    byod_ict_note: "Catatan ICT",
    byod_end_reason: "Alasan",
    byod_terms_h: "Ketentuan yang disetujui orang tua",
    byod_pub_title: "Persetujuan Orang Tua — Bring Your Own Device (BYOD)",
    byod_pub_intro: "Putra/putri Anda diajukan untuk membawa laptop, iPad, atau tablet pribadi ke sekolah guna mengerjakan project di bawah. Mohon baca ketentuan, isi data perangkat, lalu tanda tangan. Hanya laptop, iPad, dan tablet yang diizinkan; ponsel tidak diizinkan.",
    byod_pub_student: "Siswa",
    byod_pub_project: "Project",
    byod_pub_teacher: "Guru pendamping",
    byod_pub_terms_h: "Syarat dan ketentuan (centang setiap pernyataan)",
    byod_s_own_device: "Perangkat adalah milik keluarga kami dan anak saya bertanggung jawab atasnya, dengan pendampingan saya.",
    byod_s_liability: "Sekolah tidak bertanggung jawab atas kehilangan, pencurian, atau kerusakan perangkat, data, maupun aksesorinya.",
    byod_s_project_only: "Perangkat dipakai hanya untuk project di atas, dalam tanggal dan jam yang ditentukan, dan dibawa lengkap dengan charger sendiri.",
    byod_s_rules: "Anak saya akan mematuhi Kebijakan Penggunaan yang Bertanggung Jawab sekolah dan tidak mengakses konten terlarang atau menghindari pengendalian jaringan sekolah.",
    byod_s_monitoring: "Saya memahami bahwa penggunaan internet melalui jaringan sekolah dipantau dan disaring.",
    byod_s_revoke: "ICT dapat mencabut akses WiFi, dan guru dapat menahan perangkat sementara, jika aturan dilanggar atau periode berakhir.",
    byod_s_privacy: "Saya setuju data siswa dan perangkat diproses sekolah untuk keperluan ini dan disimpan sebagai catatan bertanda tangan.",
    byod_pub_devices_h: "Data perangkat (maksimal 2)",
    byod_pub_device: "Perangkat",
    byod_pub_add_device: "Tambah perangkat lain",
    byod_mac_optional: "opsional",
    byod_pub_mac_help: "Jika tidak menemukannya, boleh dikosongkan — tim ICT sekolah akan membantu mengisinya. Cara mencari MAC address WiFi: Windows — Pengaturan › Jaringan › Properti perangkat keras › Alamat fisik; macOS — Pengaturan Sistem › Jaringan › Wi-Fi › Detail › Perangkat keras; iPad — Pengaturan › Umum › Tentang › Alamat Wi-Fi; Tablet Android — Pengaturan › Tentang tablet › Status. Pada iPad/Android, MATIKAN 'Alamat Wi-Fi pribadi' untuk jaringan sekolah, jika tidak perangkat tidak bisa terhubung.",
    byod_pub_parent_h: "Orang tua / wali",
    byod_pub_signature: "Tanda tangan (gambar dengan jari atau mouse)",
    byod_pub_submit: "Saya setuju dan tanda tangan",
    byod_pub_done_title: "Terima kasih, persetujuan Anda tercatat",
    byod_pub_done_body: "Guru pendamping dan ICT sekolah akan memproses permohonan ini. Anda tidak perlu melakukan apa pun lagi. Tautan ini tidak dapat dipakai lagi.",
    byod_pub_invalid: "Tautan tidak valid, sudah dipakai, atau sudah kedaluwarsa. Mintalah guru pendamping mengirim tautan baru.",
    byod_pub_fix: "Lengkapi semua isian, centang semua pernyataan, dan tanda tangan.",
    ln_borrower: "Peminjam",
    ln_decision: "Keputusan",
    ln_decision_note: "Catatan / alasan",
    ln_decided_by: "Diputuskan oleh",
    ln_late: "Pengajuan mendadak",
    ln_late_hint: "Diajukan pada hari-H; tergantung ketersediaan.",
    ln_unit_records: "Catatan serah terima",
    ln_checkout: "Saat keluar",
    ln_checkin: "Saat kembali",
    ln_handed_by: "Diserahkan oleh",
    ln_received_by: "Diterima oleh",
    ln_fault_created: "Laporan kerusakan dibuat di",
    ln_act_decide: "Konfirmasi pengajuan",
    ln_act_supervisor: "Keputusan supervisor",
    ln_act_checkout: "Serahkan aset (check-out)",
    ln_act_checkin: "Terima pengembalian (check-in)",
    ln_act_cancel: "Batalkan pengajuan",
    ln_approve: "Setujui",
    ln_reject: "Tolak",
    ln_physical: "Kondisi fisik",
    ln_function: "Fungsi",
    ln_accessories: "Kelengkapan",
    ln_present: "Ada",
    ln_missing: "Tidak ada",
    ln_result: "Hasil pengembalian",
    ln_result_fault_hint: "Laporan kerusakan akan dibuka otomatis.",
    ln_damage_note: "Keterangan kerusakan / kehilangan",
    ln_photo_before: "Foto sebelum",
    ln_photo_before_hint: "Opsional: lampirkan foto kondisi aset sekarang; dipakai lagi saat serah terima (otomatis dikecilkan, maks. 50 KB)",
    ln_photo_after: "Foto sesudah",
    ln_photo_hint: "Ketuk untuk memotret atau memilih foto (otomatis dikecilkan, maks. 50 KB)",
    ln_phys_baik: "Baik",
    ln_phys_lecet: "Lecet",
    ln_phys_retak: "Retak",
    ln_phys_lainnya: "Lainnya",
    ln_fn_normal: "Normal",
    ln_fn_masalah: "Ada masalah",
    ln_res_ok: "OK, kondisi sama",
    ln_res_changed: "Kondisi berubah (masih bisa dipakai)",
    ln_res_damaged: "Rusak (kirim ke perbaikan)",
    ln_res_lost: "Hilang",
    ln_st_submitted: "Diajukan",
    ln_st_pending_supervisor: "Menunggu supervisor",
    ln_st_pending_ict: "Menunggu konfirmasi ICT",
    ln_st_approved: "Disetujui",
    ln_st_partially_approved: "Disetujui sebagian",
    ln_st_rejected: "Ditolak",
    ln_st_in_use: "Sedang digunakan",
    ln_st_completed: "Selesai",
    ln_st_cancelled: "Dibatalkan",
    ln_st_overdue: "Terlambat",
    ln_st_problem: "Bermasalah",
    ln_sup_pending: "Menunggu supervisor",
    ln_sup_approved: "Disetujui supervisor",
    ln_sup_rejected: "Ditolak supervisor",
    ln_unit_reserved: "Dipesan",
    ln_unit_out: "Keluar",
    ln_unit_returned: "Kembali",
    ln_unit_not_returned: "Belum kembali",
    ln_unit_lost: "Hilang",
    ln_unit_damaged: "Rusak",
    ln_settings: "Pengaturan peminjaman",
    ln_borrowable: "Bisa dipinjam",
    ln_borrowable_yes: "Aset ini bisa dipinjam.",
    ln_borrowable_no: "Aset ini tidak dibuka untuk peminjaman.",
    ln_storage_slot: "Lokasi simpan / slot",
    ln_max_days: "Maks. lama pinjam (hari)",
    ln_needs_approval: "Perlu persetujuan",
    ln_can_leave: "Boleh dibawa keluar sekolah",
    ln_use_category_rule: "Ikuti aturan kategori",
    ln_yes: "Ya",
    ln_no: "Tidak",
    ln_accessories_standard: "Kelengkapan standar (satu per baris)",
    ln_accessories_hint: "Charger\nTas\nLensa",
    ln_history: "Riwayat peminjaman",
    ln_history_empty: "Belum ada peminjaman tercatat.",

    // Schedule module
    nav_schedule: "Jadwal & lab",
    ln_cart_units_back: "Unit yang dikembalikan",
    ln_cart_units_out: "Unit yang diserahkan",
    ln_not_handed: "tidak diserahkan",
    ln_not_returned: "belum kembali",
    ln_photo_cart: "Foto seluruh cart / ruangan",
    ln_photo_cart_hint: "Semua slot / kursi harus terlihat",
    ln_problem_flag: "Laporkan masalah",
    ln_problem_remove: "Batalkan masalah",
    ln_units_still_out: "unit belum kembali",
    sc_kicker: "Ketersediaan",
    sc_title: "Jadwal & lab",
    sc_subtitle: "Kalender mingguan cart laptop / iPad dan Lab Komputer. Hijau berarti masih ada unit kosong, merah berarti terpakai penuh. Jadwal tetap kelas terkunci; pilih slot kosong untuk mengajukan pemakaian tambahan.",
    sc_setup: "Pengaturan jadwal",
    sc_no_resources: "Belum ada cart atau lab yang diatur untuk kampus Anda.",
    sc_no_periods: "Jam pelajaran kampus ini belum diatur.",
    sc_this_week: "Minggu ini",
    sc_capacity: "Unit tersedia",
    sc_legend_free: "Kosong",
    sc_legend_used: "Terpakai penuh",
    sc_period: "Jam ke",
    sc_free: "Tersisa",
    sc_full: "Penuh",
    sc_holiday: "Libur",
    sc_pending: "menunggu",
    sc_empty_slot: "Tidak ada kegiatan pada slot ini.",
    sc_request_title: "Pengajuan di luar jadwal",
    sc_until_period: "Sampai jam ke",
    sc_mon: "Sen",
    sc_tue: "Sel",
    sc_wed: "Rab",
    sc_thu: "Kam",
    sc_fri: "Jum",
    sc_sat: "Sab",
    sc_sun: "Min",
    sc_type_fixed: "Jadwal tetap",
    sc_type_booking: "Pengajuan",
    sc_type_libur: "Sesi dibatalkan (libur)",
    sc_open_session: "Serah terima sesi ini",
    sc_mark_libur: "Tandai libur",
    sc_open_loan: "Buka serah terima",
    su_tab_resources: "Cart & lab",
    su_tab_periods: "Jam pelajaran",
    su_tab_holidays: "Libur sekolah",
    su_tab_schedules: "Jadwal tetap",
    su_tab_pairings: "Pasangan unit & siswa",
    su_add: "Tambah",
    su_name: "Nama",
    su_kind: "Jenis",
    su_category: "Kategori",
    su_capacity: "Kapasitas",
    su_units: "Unit",
    su_units_edit: "Isi unit",
    su_selected: "dipilih",
    su_active: "Aktif",
    su_inactive: "nonaktif",
    su_kind_laptop_cart: "Cart laptop",
    su_kind_ipad_cart: "Cart iPad",
    su_kind_computer_lab: "Lab komputer",
    su_kind_room: "Ruangan",
    su_add_resource: "Tambah cart / lab",
    su_resource_hint: "Kapasitas dipakai sampai unit didaftarkan; setelah unit ditambahkan, hanya unit aktif yang dihitung.",
    su_no_units: "Belum ada unit di cart ini. Tambahkan di tab Cart & lab.",
    su_periods_hint: "Daftar induk jam pelajaran per unit sekolah (PAUD / SD / SMP) di kampus ini (mis. jam ke-1 = 07.30–08.10). Pilih unit lalu isi jamnya sendiri; cart/lab memakai jam unitnya di kalender dan jadwal tetap.",
    su_school_unit: "Unit sekolah",
    su_start_date: "Tanggal mulai",
    su_end_date: "Tanggal berakhir",
    su_holidays_hint: "Pengajuan diblokir dan sesi jadwal tetap tidak berjalan pada tanggal ini.",
    su_date: "Tanggal",
    su_all_campuses: "Semua kampus",
    su_add_schedule: "Tambah jadwal tetap",
    su_schedule_hint: "Diinput Admin ICT sekali per semester. Slot terkunci untuk pengajuan lain.",
    su_resource: "Cart / lab",
    su_year: "Tahun ajaran",
    su_semester: "Semester",
    su_teacher: "Guru pengampu",
    su_weekday: "Hari",
    su_period_from: "Dari jam ke",
    su_period_to: "Sampai jam ke",
    su_valid_from: "Berlaku mulai",
    su_valid_to: "Berlaku sampai",
    su_valid: "Berlaku",
    su_restore: "pulihkan",
    su_pairings_hint: "Pasangkan setiap unit dengan siswa selama satu semester (mis. iPad nomor 12 selalu dipakai siswa nomor absen 12), sehingga pemakai tiap unit selalu jelas.",
    su_paste: "Tempel daftar",
    su_apply: "Terapkan",
    su_roll: "No. absen",
    su_student: "Siswa",

    // Loans phase 3
    nav_scan: "Scan peminjaman",
    nav_scan_asset: "Scan aset",
    qr_loan_title: "Scan untuk peminjaman",
    qr_loan_subtitle: "Pindai label aset untuk melihat statusnya dan langsung menuju serah terima atau pengembalian. Saat sesi kelas berjalan, scan unit cart membuka serah terima sesi jadwal tersebut.",
    qr_handover_session: "Serah terima sesi jadwal",
    qr_session: "Sesi jadwal",
    qr_asset_kicker: "PENGECEKAN ASET",
    qr_asset_title: "Scan aset",
    qr_asset_subtitle: "Pindai label untuk membuka aset, atau daftarkan aset baru bila kodenya belum ada di sistem.",
    qr_asset_unknown: "Kode ini belum terdaftar.",
    qr_asset_register: "Daftarkan sebagai aset baru",
    ln_tab_dashboard: "Dashboard",
    qr_title: "Scan QR",
    qr_subtitle: "Pindai label aset untuk melihat statusnya dan langsung menuju serah terima atau pengembalian.",
    qr_camera_error: "Kamera tidak tersedia. Ketik kode aset sebagai gantinya.",
    qr_manual: "Atau ketik kode aset, mis. YPJ-KAM-005",
    qr_multi_toggle: "Pinjamkan beberapa unit sekaligus (scan ke keranjang)",
    qr_multi_basket: "Keranjang",
    qr_multi_empty: "Scan label tiap laptop / iPad; setiap unit yang tersedia masuk ke sini.",
    qr_multi_dup: "sudah ada di keranjang",
    qr_multi_borrower: "Peminjam",
    qr_multi_search: "Ketik nama atau email…",
    qr_multi_no_user: "Pengguna tidak ditemukan",
    qr_multi_until: "Dikembalikan paling lambat",
    qr_multi_class: "Kelas (opsional)",
    qr_multi_purpose: "Keperluan",
    qr_multi_terms: "Membuat peminjaman mencatat tanggung jawab peminjam atas unit-unit ini. Serah terima (kondisi dan foto) diselesaikan di halaman berikutnya.",
    qr_multi_create: "Buat satu peminjaman untuk {n} unit",
    qr_multi_created: "Peminjaman untuk {n} unit dibuat — selesaikan serah terima",
    qr_multi_handed: "{n} unit diserahkan",
    qr_multi_photo: "Foto bersama semua unit (opsional)",
    qr_multi_photo_ok: "foto ditambahkan",
    qr_multi_photo_hint: "Dengan foto, semua unit langsung tercatat diserahkan dalam kondisi baik pada langkah yang sama. Tanpa foto, selesaikan serah terima di halaman peminjaman (kondisi dan foto per unit).",
    qr_multi_create_out: "Buat peminjaman dan serahkan {n} unit",
    qr_scan_next: "Scan berikutnya",
    qr_reading: "Terbaca",
    qr_searching: "Mencari kode… jauhkan kamera 15–30 cm dari label",
    qr_find: "Cari",
    qr_pickup: "Akan diambil hari ini",
    qr_no_action: "Tidak ada peminjaman yang perlu diserahkan atau diterima untuk aset ini.",
    qr_open_asset: "Buka aset",
    qr_borrow: "Pinjam aset ini",
    qr_not_borrowable: "Aset ini tidak tersedia untuk dipinjam.",
    qr_print_labels: "Cetak label barcode",
    qr_print_these: "Cetak barcode",
    qr_print_one: "Cetak barcode",
    qr_picked_hint: "Menampilkan stiker barcode untuk {n} aset terpilih.",
    qr_picked_all: "Tampilkan semua aset",
    qr_labels_hint: "Tempel barcode pada aset. Pindai di menu Scan peminjaman / Scan aset dengan kamera atau scanner barcode USB.",
    qr_select_all: "Pilih semua",
    qr_print: "Cetak",
    qr_scan_units: "Pindai unit",
    pick_selected: "dipilih",
    pick_hint: "Pindai QR tiap perangkat atau cari namanya, agar semua perangkat yang dipinjam tercatat.",
    pick_search: "Cari nama perangkat / kode aset",
    pick_full: "Sudah {n} perangkat dipilih (sesuai jumlah disetujui). Hapus centang satu dulu.",
    pick_none: "Tidak ada perangkat yang cocok.",
    qr_scanned: "terpindai",
    qr_not_in_cart: "bukan bagian cart ini",
    qr_done: "Selesai",
    db_pending: "Menunggu konfirmasi",
    db_out: "Sedang dipinjam",
    db_not_returned: "Belum kembali",
    db_broken: "Rusak / hilang",
    db_today: "Hari ini",
    db_none_late: "Tidak ada yang terlambat.",
    db_last_user: "Pemakai terakhir",
    db_due: "Jatuh tempo",
    db_contact: "Kontak",
    rp_loans_title: "Laporan peminjaman",
    rp_usage: "Pemakaian bulanan",
    rp_usage_desc: "Pemakaian per kelas serta pengajuan di luar jadwal (disetujui dan ditolak) sebagai bahan evaluasi kebutuhan jumlah unit.",
    rp_show: "Tampilkan",
    rp_by_class: "Pemakaian per kelas",
    rp_fixed: "Sesi jadwal tetap",
    rp_extra: "Sesi tambahan",
    rp_hours: "Jam",
    rp_off_schedule: "Pengajuan di luar jadwal",
    rp_off_hint: "Banyak pengajuan ditolak, atau unit diminta jauh di atas unit diberikan, menandakan unit mungkin kurang.",
    rp_requests: "Pengajuan",
    rp_approved: "Disetujui",
    rp_partial: "Sebagian",
    rp_rejected: "Ditolak",
    rp_units_req: "Unit diminta",
    rp_units_ok: "Unit diberikan",
    rp_items: "Pinjam barang",
    rp_loans: "Pinjaman",
    rp_problems: "Bermasalah",
    rp_incidents: "Kerusakan & kehilangan",
    rp_incidents_desc: "Kode aset, kronologi, pemakai terakhir, foto terakhir dan tindak lanjut untuk setiap pengembalian yang kondisinya berubah.",
    rp_code: "Aset",
    rp_chronology: "Kronologi",
    rp_follow_up: "Tindak lanjut",
    us_phone: "Nomor WhatsApp",
    us_phone_hint: "Dipakai untuk notifikasi peminjaman (awali dengan 0 atau 62).",
  },
};

export const CATEGORY_VALUES = [
  "IT Equipment", "AV Equipment", "Furniture", "Lab Equipment",
  "Vehicles", "Books", "Sports", "Music Equipment",
  "Learning Tools", "ERG / Fire Drill Equipment", "Housekeeping Equipment", "First Aid / AED Equipment", "Work Tools", "Other",
];

export const CATEGORY_KEYS = [
  "cat_it", "cat_av", "cat_furniture", "cat_lab",
  "cat_vehicles", "cat_books", "cat_sports", "cat_music",
  "cat_learning", "cat_erg", "cat_housekeeping", "cat_firstaid", "cat_tools", "cat_other",
];

export const STATUS_KEYS = {
  active: "status_active",
  in_repair: "status_in_repair",
  retired: "status_retired",
  lost: "status_lost",
};
